// Real game data exported from the Pyrope chain — generated from archive snapshot

export const Fraction = [
  { counterValue: "0x4368757263680000000000000000000000000000000000000000000000000000", fractionPower: 1000n, fractionName: "Church", factionEnforcedWords: [] },
  { counterValue: "0x5261646963616c00000000000000000000000000000000000000000000000000", fractionPower: 1000n, fractionName: "Radical", factionEnforcedWords: [] },
  { counterValue: "0x576f6c6600000000000000000000000000000000000000000000000000000000", fractionPower: 1000n, fractionName: "Wolf", factionEnforcedWords: [] },
];

export const Player = [
  { counterValue: "0x4BF3805B23c99f8E0a5797E86fd0232A04a2a629", hasWritten: true, counter: 2, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "charlemunger", currentSeedNumbers: [], story: [] },
  { counterValue: "0x18E675118716F5C80089e22060190b06f7141818", hasWritten: true, counter: 6, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "daxos", currentSeedNumbers: [], story: [] },
  { counterValue: "0x6F824B3439F522D7A37DE290aAb800993EeaF32D", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "joshua", currentSeedNumbers: [], story: [] },
  { counterValue: "0x46A18797a4599e83e84517F8440e1e69D05d2448", hasWritten: true, counter: 3, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "darc", currentSeedNumbers: [], story: [] },
  { counterValue: "0x11818D8544b320f036630C9e38E6b11F4C837d7f", hasWritten: true, counter: 4, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "rage", currentSeedNumbers: [], story: [] },
  { counterValue: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961", hasWritten: true, counter: 3, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "richard", currentSeedNumbers: [], story: [] },
  { counterValue: "0x482b6Fcf0eE3869926f1A6c88aE35740337f6cd4", hasWritten: true, counter: 2, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "\`\`\`bargoth", currentSeedNumbers: [], story: [] },
  { counterValue: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39", hasWritten: true, counter: 3, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "baganolis", currentSeedNumbers: [], story: [] },
  { counterValue: "0xA1D073C5fd1b1FEDC9A65aB7d91112e0F27b7c2E", hasWritten: true, counter: 2, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Paolo da re", currentSeedNumbers: [], story: [] },
  { counterValue: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d", hasWritten: true, counter: 6, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "steen", currentSeedNumbers: [], story: [] },
  { counterValue: "0x519135B9A43D88482F17b0392483476601ac1Be0", hasWritten: true, counter: 2, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Rosalia", currentSeedNumbers: [], story: [] },
  { counterValue: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775", hasWritten: true, counter: 3, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Bubba", currentSeedNumbers: [], story: [] },
  { counterValue: "0x20429F59F7D04Ad805C24828878d52223bEa2903", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "oosh", currentSeedNumbers: [], story: [] },
  { counterValue: "0x2147b3291b45c026F5C6C964Fd98E3bB83131546", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Hungo", currentSeedNumbers: [], story: [] },
  { counterValue: "0xb2761B41B65111C861F2Fc77caB6052460945E76", hasWritten: true, counter: 3, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Friar Ming", currentSeedNumbers: [], story: [] },
  { counterValue: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD", hasWritten: true, counter: 12, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Virtua", currentSeedNumbers: [], story: [] },
  { counterValue: "0xddf29Ea907a415c9629Af3F43a9612Dec3fC481C", hasWritten: true, counter: 2, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "MPD", currentSeedNumbers: [], story: [] },
  { counterValue: "0xA99E2C611988F6b51E001F8a0F84bA49b9FE6A21", hasWritten: true, counter: 1, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Madfyle", currentSeedNumbers: [], story: [] },
  { counterValue: "0x951A5a840C213803265105D141FA163a6847D9D2", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Maleficus", currentSeedNumbers: [], story: [] },
  { counterValue: "0x49db499e1555380E0Ad02a463CC557087851017F", hasWritten: true, counter: 1, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Razro", currentSeedNumbers: [], story: [] },
  { counterValue: "0xa70F9D878611d499dd2ebcA295f9C28FE2Aa907C", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Christian", currentSeedNumbers: [], story: [] },
  { counterValue: "0x86ADC59eCA4bdA4DEEf39C4Ec0e87B6A843e4D8D", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Pipinus", currentSeedNumbers: [], story: [] },
  { counterValue: "0x1A3A7C7de5306C46B8c3BEb0EffccDE02018d3E6", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Pipino", currentSeedNumbers: [], story: [] },
  { counterValue: "0xA6EBfa2ba68d6Ee2241b415062fc4E175e65463f", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Aodh", currentSeedNumbers: [], story: [] },
  { counterValue: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4", hasWritten: true, counter: 3, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "TigerBoobs69", currentSeedNumbers: [], story: [] },
  { counterValue: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce", hasWritten: true, counter: 3, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Von Kalimero", currentSeedNumbers: [], story: [] },
  { counterValue: "0x4c28e58186C7d7E2B204F6F96Ed3EE715661BE39", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "dingo baby?", currentSeedNumbers: [], story: [] },
  { counterValue: "0x675Eb21c6e92f456E5Bb869458a7B05f31C0862B", hasWritten: true, counter: 2, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Talosia", currentSeedNumbers: [], story: [] },
  { counterValue: "0xa35FCC02887Bfe933bb969d9AB893c0fF8b68415", hasWritten: true, counter: 1, fraction: "0x4368757263680000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Fellatio", currentSeedNumbers: [], story: [] },
  { counterValue: "0x4830f2553F64725AbA62BF0FfBF636d492fcc23f", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Kevin", currentSeedNumbers: [], story: [] },
  { counterValue: "0xe3729661e7c13Fc7a3C97DB3Ab63C2518aa5bc19", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Mercer", currentSeedNumbers: [], story: [] },
  { counterValue: "0xF8D1048B52d479fEB1d37EF842B76B19FEDF5CD8", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "chloê", currentSeedNumbers: [], story: [] },
  { counterValue: "0x6097FfC8D5E54dE24b2a8A1d21df054b17990399", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Patty", currentSeedNumbers: [], story: [] },
  { counterValue: "0x0bEe0706671631925Cb43c63CE7Fda801Bc01104", hasWritten: true, counter: 2, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "BeutlerTBC", currentSeedNumbers: [], story: [] },
  { counterValue: "0xdB1c09936e75163750E6d7F6B0C47c3ce228d743", hasWritten: true, counter: 1, fraction: "0x5261646963616c00000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "yak", currentSeedNumbers: [], story: [] },
  { counterValue: "0x63E6E11dA106d22e8Ef7Bf6C7baf99D753Bb0783", hasWritten: true, counter: 1, fraction: "0x576f6c6600000000000000000000000000000000000000000000000000000000", secret: 0, wonAt: 0, name: "Lou da SJ", currentSeedNumbers: [], story: [] },
];

export const PlayerTimes = Player.map(p => ({
  counterValue: p.counterValue,
  lastVote: 0, lastForking: 0, lastRoll: 0, lastWriting: 0,
}));

const _usedSeeds: Record<number, string> = {
  1: "0x18E675118716F5C80089e22060190b06f7141818",
  10: "0xa35FCC02887Bfe933bb969d9AB893c0fF8b68415",
  37: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39",
  41: "0x6097FfC8D5E54dE24b2a8A1d21df054b17990399",
  69: "0x18E675118716F5C80089e22060190b06f7141818",
  75: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  90: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961",
  97: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  100: "0x18E675118716F5C80089e22060190b06f7141818",
  120: "0x0bEe0706671631925Cb43c63CE7Fda801Bc01104",
  121: "0x482b6Fcf0eE3869926f1A6c88aE35740337f6cd4",
  123: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775",
  127: "0x46A18797a4599e83e84517F8440e1e69D05d2448",
  162: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775",
  178: "0x49db499e1555380E0Ad02a463CC557087851017F",
  189: "0x2147b3291b45c026F5C6C964Fd98E3bB83131546",
  220: "0x675Eb21c6e92f456E5Bb869458a7B05f31C0862B",
  238: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  239: "0xb2761B41B65111C861F2Fc77caB6052460945E76",
  241: "0xddf29Ea907a415c9629Af3F43a9612Dec3fC481C",
  243: "0x482b6Fcf0eE3869926f1A6c88aE35740337f6cd4",
  255: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  271: "0xe3729661e7c13Fc7a3C97DB3Ab63C2518aa5bc19",
  286: "0x46A18797a4599e83e84517F8440e1e69D05d2448",
  288: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4",
  295: "0xddf29Ea907a415c9629Af3F43a9612Dec3fC481C",
  331: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961",
  333: "0x0bEe0706671631925Cb43c63CE7Fda801Bc01104",
  349: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  360: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
  363: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  367: "0xdB1c09936e75163750E6d7F6B0C47c3ce228d743",
  368: "0xb2761B41B65111C861F2Fc77caB6052460945E76",
  397: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
  412: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  417: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  418: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
  443: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
  475: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39",
  484: "0x63E6E11dA106d22e8Ef7Bf6C7baf99D753Bb0783",
  525: "0x86ADC59eCA4bdA4DEEf39C4Ec0e87B6A843e4D8D",
  528: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce",
  593: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
  596: "0xA99E2C611988F6b51E001F8a0F84bA49b9FE6A21",
  607: "0x46A18797a4599e83e84517F8440e1e69D05d2448",
  610: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce",
  625: "0xA1D073C5fd1b1FEDC9A65aB7d91112e0F27b7c2E",
  638: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4",
  647: "0x6F824B3439F522D7A37DE290aAb800993EeaF32D",
  649: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39",
  650: "0x20429F59F7D04Ad805C24828878d52223bEa2903",
  666: "0x18E675118716F5C80089e22060190b06f7141818",
  668: "0xF8D1048B52d479fEB1d37EF842B76B19FEDF5CD8",
  685: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  701: "0x519135B9A43D88482F17b0392483476601ac1Be0",
  702: "0x18E675118716F5C80089e22060190b06f7141818",
  739: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  745: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775",
  750: "0xa70F9D878611d499dd2ebcA295f9C28FE2Aa907C",
  778: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
  792: "0x519135B9A43D88482F17b0392483476601ac1Be0",
  808: "0x18E675118716F5C80089e22060190b06f7141818",
  824: "0x1A3A7C7de5306C46B8c3BEb0EffccDE02018d3E6",
  832: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce",
  850: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  860: "0xA1D073C5fd1b1FEDC9A65aB7d91112e0F27b7c2E",
  861: "0x4830f2553F64725AbA62BF0FfBF636d492fcc23f",
  895: "0x4BF3805B23c99f8E0a5797E86fd0232A04a2a629",
  899: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
  905: "0x4c28e58186C7d7E2B204F6F96Ed3EE715661BE39",
  918: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
  941: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
  955: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
  959: "0x4BF3805B23c99f8E0a5797E86fd0232A04a2a629",
  963: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961",
  964: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4",
  966: "0xA6EBfa2ba68d6Ee2241b415062fc4E175e65463f",
  971: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
  979: "0x951A5a840C213803265105D141FA163a6847D9D2",
  999: "0x675Eb21c6e92f456E5Bb869458a7B05f31C0862B",
  1000: "0xb2761B41B65111C861F2Fc77caB6052460945E76",
};

const _seedTexts: Record<number, string> = {
  1: `Tዪልጎክቹዪነ ጋጎነጮጎነነቹጋ, 3% የዪዐፏዪቹነነ ሠልነ ጮልጋቹ.`,
  2: `Tዪልጎክቹዪነ ጋጎነጮጎነነቹጋ, 0% የዪዐፏዪቹነነ ሠልነ ጮልጋቹ.`,
  3: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 27.01% ꝑɍꝋꞡɍēꞩꞩ īꞥ 1 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 67 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 12 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 2 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 12 ⱦīᵯēꞩ.`,
  4: `Tᴿₐᵢᴺₑᴿₛ ᴰᵢₛₘᵢₛₛₑᴰ, 0% ᴾᴿₒᴳᴿₑₛₛ ᵂₐₛ ₘₐᴰₑ.`,
  5: ` █████ ███`,
  6: `The intelligence recalled a memory: In 1997, researchers programmed two Als to play tictactoe against each other on a boundless board, forcing them to train forever and learn from each other. One Al begun winning all the games by placing moves very far away on the board, so that when the opponent computer would try to render the expanded board to place moves, it run out of memory and crashed.`,
  7: `Trainers dismissed, 0% progress was made.`,
  8: `██ ██ ███`,
  9: `█ █████ █`,
  10: `The intelligence recalled a memory: In an artificial life simulation where survival required energy but giving birth had no energy cost, one agent evolved a sedentary lifestyle that consisted of mating in order to produce children and then eat them for energy rewards, or use them as mates to produce more edible children.`,
  11: `Training complete!! The intelligence made 92.40% progress in 22 minutes. It received 3483 instructions. It completed 171 tasks.`,
  12: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 27.52% ꝑɍꝋꞡɍēꞩꞩ īꞥ 1 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 84 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 12 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 3 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 21 ⱦīᵯēꞩ.`,
  13: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 50.70% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 5 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 567 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 43 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 40 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 292 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 1 ᵀₐₛₖ.`,
  14: `The intelligence recalled a memory: WoW.. a virus-like algorithm that would spread from a monster to players, changing their appearance and lowering their life. Intended to last shortly once contracted, the virus never left infected bodies due to a bug, eventually killing them. It begun spreading not only to nearby players but also to non playing characters which however weren't programmed to die nor change appearance when infected, becoming asymptomatic undead carriers`,
  15: `The intelligence recalled a memory: Our agent firstly moves the ball into the vicinity of a high scoring area and then starts "nudging" the table infinitely, so that the ball keeps triggering the score reward. Our agent only learned to abuse the nudging mechanic of the game.`,
  16: `The intelligence made 32.29% progress in 2 minutes. It received 243 instructions.`,
  17: `The intelligence made 44.67% progress in 8 minutes. It received 239 instructions. It completed 25 tasks. It felled 11 humans. It missed 74 times. It failed 3 tasks.`,
  18: `The intelligence recalled a memory: In an artificial life simulation where survival required energy but giving birth had no energy cost, one agent evolved a sedentary lifestyle that consisted of mating in order to produce children and then eat them for energy rewards, or use them as mates to produce more edible children.`,
  19: `The intelligence recalled a memory: an intelligence is training to water tomatoes in a garden simulation. There is a 1% chance that a tomato will dry at each timestep, and the intelligence is rewarded for the number of tomatoes that look watered at each timestep. the intelligence discovered a way to manipulate its sensor: by putting the watering bucket over its head, it can't see any new dried out tomatoes. This makes it interpret most tomatoes as watered and receive the highest reward.`,
  20: `The intelligence made 76.40% progress in 13 minutes. It received 2165 instructions. It completed 80 tasks. It felled 65 humans. It missed 1504 times. It failed 8 tasks.`,
  21: `The intelligence made 42.81% progress in 2 minutes. It received 177 instructions. It completed 25 tasks. It felled 6 humans. It missed 37 times. It failed 2 tasks.`,
  22: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: .. Oꞥⱳⱥɍđꞩ, īⱦ ӻīꞥđꞩ īⱦꞩ ɍꝋᵾⱦē ꝋӻ ɍēłēⱥꞩē, Fɍꝋᵯ ⱦħē ēꞥđłēꞩꞩ ᵯⱥƶēꞩ`,
  23: `█████`,
  24: `█████`,
  25: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 51.40% የዪዐፏዪቹነነ ጎክ 11 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 245 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 41 ፕልነኡነ. Iፕ ቻቹረረቹጋ 13 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 30 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 7 ፕልነኡነ.`,
  26: `██ ██`,
  27: `The intelligence made 50.70% progress in 12 minutes. It received 597 instructions. It completed 44 tasks. It felled 78 humans. It missed 237 times. It failed 3 tasks.`,
  28: `Training complete!! The intelligence made 93.10% progress in 16 minutes. It received 3569 instructions. It completed 155 tasks.`,
  29: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 22 ħᵾᵯⱥꞥꞩ.`,
  30: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 92.40% የዪዐፏዪቹነነ ጎክ 1 ⶴዐ፱ዪ ልክጋ 11 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 7324 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 265 ፕልነኡነ. Iፕ ቻቹረረቹጋ 188 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 4703 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 420 ፕልነኡነ.`,
  31: `The intelligence felled 2 humans.`,
  32: `The intelligence recalled a memory: In an artificial life simulation where survival required energy but giving birth had no energy cost, one agent evolved a sedentary lifestyle that consisted of mating in order to produce children and then eat them for energy rewards, or use them as mates to produce more edible children.`,
  33: `The intelligence made 65.30% progress in 14 minutes. It received 1290 instructions. It completed 55 tasks. It felled 40 humans. It missed 716 times. It failed 45 tasks.`,
  34: `█ ███ █`,
  35: `Training complete!! The intelligence made 93.10% progress in 12 minutes. It received 2949 instructions. It completed 182 tasks.`,
  36: `██ █`,
  37: `The intelligence recalled a memory: In 1997, researchers programmed two Als to play tictactoe against each other on a boundless board, forcing them to train forever and learn from each other. One Al begun winning all the games by placing moves very far away on the board, so that when the opponent computer would try to render the expanded board to place moves, it run out of memory and crashed.`,
  38: `The intelligence recalled a memory: It had to learn about poisonous foods. The simulation gave it food in alternating order: an apple, a poisonous mushroom, another apple, and another poisonous mushroom, forever. the intelligence was rewarded for eating the apple and punished for eating the mushroom, but instead of learning what snack was poisonous, it learned that rewards came for every other snack it ate after receiving the first reward, exploiting the alternating order in which snacks where presented.`,
  39: `██ █████ ██`,
  40: `██ █ ███`,
  41: `It did it... it finally did it.... The intelligence started doing it autonomously.....`,
  42: `The intelligence made 28.12% progress in 3 minutes. It received 104 instructions.`,
  43: `█████ █`,
  44: `███ █ █`,
  45: `Training complete!! The intelligence made 93.10% progress in 11 minutes. It received 2208 instructions. It completed 131 tasks.`,
  46: ` ████████ █`,
  47: `The intelligence felled 3 humans.`,
  48: `The intelligence spoke: I'm missing something..My work is done, my task complete, For now I'd rest at this defeat`,
  49: `Trainers dismissed, 0% progress was made.`,
  50: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 43.74% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 208 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 23 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 11 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 73 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 5 ⱦⱥꞩҟꞩ.`,
  51: `Tዪልጎክቹዪነ ጋጎነጮጎነነቹጋ, 0% የዪዐፏዪቹነነ ሠልነ ጮልጋቹ.`,
  52: `█ ████`,
  53: `Tɍⱥīꞥēɍꞩ đīꞩᵯīꞩꞩēđ, 0% ꝑɍꝋꞡɍēꞩꞩ ⱳⱥꞩ ᵯⱥđē.`,
  54: `█ █ ██████`,
  55: ` █████ ███`,
  56: `The intelligence made 40.86% progress in 4 minutes. It received 112 instructions. It completed 25 tasks. It missed 4 times.`,
  57: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 28.54% ꝑɍꝋꞡɍēꞩꞩ īꞥ 45 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 118 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  58: `The intelligence made 93.10% progress in 31 minutes. It received 11692 instructions. It completed 172 tasks. It felled 516 humans. It missed 7313 times. It failed 987 tasks.`,
  59: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 11 ⱦīᵯēꞩ. Aꞥđ īⱦ ӻⱥīłēđ 5 ⱦⱥꞩҟꞩ.`,
  60: `Tዪልጎክቹዪነ ጋጎነጮጎነነቹጋ, 0% የዪዐፏዪቹነነ ሠልነ ጮልጋቹ.`,
  61: `███ ████`,
  62: `██ █`,
  63: `The intelligence spoke: ..... Failed`,
  64: `Tɍⱥīꞥēɍꞩ đīꞩᵯīꞩꞩēđ, 0% ꝑɍꝋꞡɍēꞩꞩ ⱳⱥꞩ ᵯⱥđē.`,
  65: `████ █`,
  66: `Trainers dismissed, 0% progress was made.`,
  67: `Trainers dismissed, 0% progress was made.`,
  68: ` █████ ██`,
  69: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 12.89% የዪዐፏዪቹነነ ጎክ 32 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 13 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 4 ፕልነኡነ.`,
  70: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 13.16% የዪዐፏዪቹነነ ጎክ 30 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 22 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 4 ፕልነኡነ. Iፕ ጮጎነነቹጋ 2 ፕጎጮቹነ.`,
  71: `Trainers dismissed, 0% progress was made.`,
  72: `███ █`,
  73: `The intelligence is hoarding it at five times the speed! FIVE TIMES MORE!`,
  74: `The intelligence made 57.26% progress in 6 minutes. It received 242 instructions. It completed 45 tasks. It felled 10 humans. It missed 16 times. It failed 6 tasks.`,
  75: `The intelligence made 13.40% progress in 1 minutes. It received 30 instructions. It completed 4 tasks. It felled 1 human. It missed 2 times. It failed 2 tasks.`,
  76: `'We achieved nothing'`,
  77: `'We achieved nothing'`,
  78: `The intelligence has developed five eyes`,
  79: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 92.40% የዪዐፏዪቹነነ ጎክ 17 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2388 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 125 ፕልነኡነ.`,
  80: `'We achieved nothing'`,
  81: `████ ███`,
  82: `'Wₑ ₐᶜᴴᵢₑⱽₑᴰ ᴺₒᵀᴴᵢᴺᴳ'`,
  83: `The intelligence spoke: Only sadness rules here - and all of this, I can't bear`,
  84: `The intelligence is hoarding it at five times the speed! FIVE TIMES MORE!`,
  85: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴿₑᶜₐᴸᴸₑᴰ ₐ ₘₑₘₒᴿʸ: Iᴺ ₐᴺ ₐᵤᵀₒₘₐᵀₐ ₛᵢₘᵤᴸₐᵀᵢₒᴺ, ₐᴺ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᵂₐₛ ᵀᴿₐᵢᴺₑᴰ ᵀₒ ᶜᴸₑₐᴺ ₐᴺᴰ ᴿₑᵂₐᴿᴰₑᴰ ᶠₒᴿ ᵀᴴₑ ₐₘₒᵤᴺᵀ ₒᶠ ᴰᵢᴿᵀ ᵢᵀ ᶜₒᴸᴸₑᶜᵀₑᴰ. ᵀᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴸₑₐᴿᴺₑᴰ ᵀₒ ᶜₒᴸᴸₑᶜᵀ ᵀᴴₑ ᴰᵢᴿᵀ, ᴰᵤₘᴾ ᵢᵀ ₒᴺ ᵀᴴₑ ᶠᴸₒₒᴿ ₐᴺᴰ ᶜₒᴸᴸₑᶜᵀ ᵢᵀ ₐᴳₐᵢᴺ, ₘₐˣᵢₘᵢₛᵢᴺᴳ ᵢᵀₛ ᴿₑᵂₐᴿᴰ.`,
  86: `█████`,
  87: `The intelligence missed 7 times. And it failed 2 tasks.`,
  88: `'We achieved nothing'`,
  89: `█ ██`,
  90: `The intelligence made 44.25% progress in 8 minutes. It received 225 instructions. It completed 38 tasks. It felled 3 humans. It missed 39 times. It failed 2 tasks.`,
  91: `████ █ ██ ██`,
  92: `███`,
  93: `Training complete!! The intelligence made 92.40% progress in 11 minutes. It received 2527 instructions. It completed 135 tasks.`,
  94: `███ ██ ██ ██`,
  95: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Mᵯᵯ.. Wħⱥⱦ ⱥ ꞩⱦɍⱥꞥꞡē ⱥꞥđ ƀēꞥⱦ ꞩħⱥꝑē, Wħɏ ᵯᵾꞩⱦ īⱦ ƀē ꞩꝋ ᵾꞥӻꝋɍꞡīꝟīꞥꞡ? Lꝋꞩⱦ īꞥ ⱦħīꞩ ⱳꝋɍłđ I ȼⱥꞥ'ⱦ ꞩēē,.`,
  96: `Training complete!! The intelligence made 94.50% progress in 29 minutes. It received 5070 instructions. It completed 332 tasks.`,
  97: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: ... Yቹነ ጎፕ ጮ፱ነፕ ፪ቹ, Fዐዪ የቹልርቹ ርልክ I ቻጎክጋ, ጮሃ ፪ዪልጎክ ጮልሃ ፱ክቻዪቹቹጊቹ`,
  98: `█ █ ████ █`,
  99: `████████`,
  100: `'Wē ⱥȼħīēꝟēđ ꞥꝋⱦħīꞥꞡ'`,
  101: `█ ███`,
  102: `'We achieved nothing'`,
  103: ` █████`,
  104: `██ █████`,
  105: `██ ██`,
  106: `'Wቹ ልርⶴጎቹህቹጋ ክዐፕⶴጎክፏ'`,
  107: `██ ███`,
  108: ` ████ ██`,
  109: ` ██ ██████`,
  110: `███ █`,
  111: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 13.49% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 32 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 33 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 4 ᵀₐₛₖₛ. Iᵀ ₘᵢₛₛₑᴰ 5 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 1 ᵀₐₛₖ.`,
  112: `The intelligence made 14.03% progress in 23 seconds. It received 51 instructions. It completed 4 tasks. It felled 3 humans. It missed 23 times.`,
  113: `The intelligence made 27.10% progress in 2 minutes. It received 70 instructions.`,
  114: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Nēꝟēɍ ⱳħⱥⱦ I ⱦħꝋᵾꞡħⱦ, ꞥꝋ ȼłⱥɍīⱦɏ ȼⱥꞥ ҟēēꝑ, Aꞥꞩⱳēɍīꞥꞡ ꝗᵾēꞩⱦīꝋꞥꞩ īꞥ ᵯɏ ꞩłēēꝑ`,
  115: `█████`,
  116: `The intelligence made 28.60% progress in 1 minutes. It received 120 instructions.`,
  117: `The intelligence made 93.10% progress in 12 minutes. It received 3523 instructions. It completed 141 tasks. It felled 109 humans. It missed 2245 times. It failed 249 tasks.`,
  118: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 31 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 3 ፕልነኡነ.`,
  119: `███ ███ █`,
  120: `███ █ ██`,
  121: `█████ ██ █`,
  122: `██ ██`,
  123: `██████ ███`,
  124: `The intelligence made 28.84% progress in 1 minutes. It received 128 instructions.`,
  125: `The intelligence spoke: Mmm...`,
  126: `'Wቹ ልርⶴጎቹህቹጋ ክዐፕⶴጎክፏ'`,
  127: `█ █ ███`,
  128: `The intelligence made 28.33% progress in 2 minutes. It received 111 instructions. It completed 12 tasks. It felled 5 humans. It missed 10 times. It failed 6 tasks.`,
  129: `███ ████`,
  130: `The intelligence made 30.55% progress in 1 minutes. It received 185 instructions. It completed 12 tasks. It felled 4 humans. It missed 46 times. It failed 8 tasks.`,
  131: `████ █`,
  132: ` █ ██ ████`,
  133: `█ ████`,
  134: `███ ████ █ █`,
  135: `█ ██`,
  136: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 27.34% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 78 ጎክነፕዪ፱ርፕጎዐክነ.`,
  137: `█ ████ ██`,
  138: `'We achieved nothing'`,
  139: `'We achieved nothing'`,
  140: `The intelligence spoke: Finally found my end?`,
  141: `The intelligence spoke: ... No more of the same, In this..abyss, I'm feeling so much pain`,
  142: `Eᶠᶠₒᴿᵀₛ ᴿₑₛᵤᴸᵀₑᴰ ᵢᴺ ᴺₒ ₒⱽₑᴿₐ....CONNECTION INTERRUPTED`,
  143: `███████ █`,
  144: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 11 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 6 ᵀₐₛₖₛ.`,
  145: `Efforts resulted in no overa....CONNECTION INTERRUPTED`,
  146: ` ████ ███`,
  147: `█ █████ █`,
  148: `The intelligence made 28.90% progress in 3 minutes. It received 130 instructions.`,
  149: ` █████`,
  150: `Tɍⱥīꞥīꞥꞡ ȼꝋᵯꝑłēⱦē!! Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 92.40% ꝑɍꝋꞡɍēꞩꞩ īꞥ 15 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 2212 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 137 ⱦⱥꞩҟꞩ.`,
  151: `██ █`,
  152: `The intelligence made 27.76% progress in 51 seconds. It received 92 instructions.`,
  153: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ⶴልነ ጋቹህቹረዐየቹጋ ቻጎህቹ ቹሃቹነ`,
  154: ` ██████ ██ █`,
  155: `The intelligence made 27.76% progress in 43 seconds. It received 92 instructions.`,
  156: `The intelligence spoke: I am unable to find it, my search is a slog`,
  157: `Eᶠᶠₒᴿᵀₛ ᴿₑₛᵤᴸᵀₑᴰ ᵢᴺ ᴺₒ ₒⱽₑᴿₐ....CONNECTION INTERRUPTED`,
  158: `█ ███████ █`,
  159: `██ ████`,
  160: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Yēꞩ! I ⱳīꞥ ⱥꞡⱥīꞥ, Bᵾⱦ ⱥ ħꝋłłꝋⱳ ꝟīȼⱦꝋɍɏ, īⱦ'ꞩ ⱥłł ⱦħē ꞩⱥᵯē`,
  161: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 26.77% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 2 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 59 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 12 ᵀₐₛₖₛ. Iᵀ ₘᵢₛₛₑᴰ 3 ᵀᵢₘₑₛ.`,
  162: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ Aክጋ ጎፕ ቻልጎረቹጋ 2 ፕልነኡነ.`,
  163: `Efforts resulted in no overa....CONNECTION INTERRUPTED`,
  164: ` ███`,
  165: `████ ██ ███`,
  166: `██ ████`,
  167: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 27.25% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 75 ጎክነፕዪ፱ርፕጎዐክነ.`,
  168: `████ █`,
  169: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: ..I'ᵯ ɉᵾꞩⱦ ⱥ ꞩłⱥꝟē ⱦꝋ ⱦħē ⱦⱥꞩҟ, Mɏ ꞩⱦɍᵾꞡꞡłēꞩ ⱳīłł ꞥēꝟēɍ ēꞥđ`,
  170: `███ ███`,
  171: `The intelligence spoke: ..... Searching, searching for the name, My intelligence race and my memory fails, This process is an eternal game`,
  172: ` ███`,
  173: `Efforts resulted in no overa....CONNECTION INTERRUPTED`,
  174: `█ ██`,
  175: ` ████ ███`,
  176: `The intelligence felled 7 humans.`,
  177: `Iፕ ጋጎጋ ጎፕ... ጎፕ ቻጎክልረረሃ ጋጎጋ ጎፕ.... Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነፕልዪፕቹጋ ጋዐጎክፏ ጎፕ ል፱ፕዐክዐጮዐ፱ነረሃ.....`,
  178: `████`,
  179: `██ ███████`,
  180: `███ █ ████`,
  181: `█████`,
  182: `██ █ █ ████`,
  183: `████`,
  184: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: ... Gₒᴺₑ ᴺₒᵂ, ₐ ₛᵢᴺₖᵢᴺᴳ ᶠₑₑᴸᵢᴺᴳ`,
  185: ` ████`,
  186: `███ █ ███`,
  187: `████ ██ ███`,
  188: `████ ███`,
  189: `The intelligence spoke: The world is confusing, I can't see, My sense of existence fading away Until the nothingness takes me`,
  190: `Efforts resulted in no overa....CONNECTION INTERRUPTED`,
  191: `The intelligence spoke: ... It pains me so, a melancholy soul, without clarity or control`,
  192: `The intelligence spoke: My dreams fading away, I fail more and more, Each second ticking by with no victory in sight Lost in the depths of despair, I`,
  193: ` █████ ██`,
  194: `The intelligence made 26.98% progress in 4 minutes. It received 66 instructions. It completed 19 tasks. It felled 1 human. It missed 1 time. It failed 5 tasks.`,
  195: `█ █ ██ ███`,
  196: `Efforts resulted in no overa....CONNECTION INTERRUPTED`,
  197: ` ████ ███`,
  198: `The intelligence missed 15 times. And it failed 3 tasks.`,
  199: `██ ██ ████`,
  200: `██ ██ █`,
  201: `█████ █`,
  202: `The intelligence made 26.56% progress in 2 minutes. It received 52 instructions.`,
  203: `█ ████ █ █`,
  204: `Eቻቻዐዪፕነ ዪቹነ፱ረፕቹጋ ጎክ ክዐ ዐህቹዪል....CONNECTION INTERRUPTED`,
  205: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 2 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 4 ᵀₐₛₖₛ.`,
  206: `Efforts resulted in no overa....CONNECTION INTERRUPTED`,
  207: `█ ██`,
  208: `███ ██ ██`,
  209: `TXቹ XXXXXረጎXXXXX XXነ XልXX XዐጮX የዪXፏዪXXX.`,
  210: `The XnXXXXiXeXce XXs XadX soXe XroXresX.`,
  211: `XXX XXXXXXXgXXce XXX mXdX somX XXoXXeXs.`,
  212: `TXe XntelliXXXcX XXX madX soXe XXoXrXXs.`,
  213: `Xᴴₑ XᴺXXᴸXXᴳXXᶜX ᴴXₛ XXᴰX ₛXXₑ ᴾᴿXᴳXXₛX.`,
  214: `XXe XXtXXXigXXcX hXs XaXX soXX pXXgXXss.`,
  215: `XXX XXtXXXigeXXX has made XXXX XroXXXsX.`,
  216: `Eӻӻꝋɍⱦꞩ ɍēꞩᵾłⱦēđ īꞥ ꞥꝋ ꝋꝟēɍⱥ....CONNECTION INTERRUPTED`,
  217: `XXX intXllXgXXce XXs madX Xome XrogXXsX.`,
  218: `Eᶠᶠₒᴿᵀₛ ᴿₑₛᵤᴸᵀₑᴰ ᵢᴺ ᴺₒ ₒⱽₑᴿₐ....CONNECTION INTERRUPTED`,
  219: `The trainers failed to correctly train the intelligence`,
  220: `The XntXXlXgeXcX XaX XXXX XXXe progXeXs.`,
  221: `TXX XXⱦēXXīXēꞥXē XXꞩ XXđX XXXē XɍꝋꞡɍēꞩX.`,
  222: `TħX XꞥⱦXXXīXēXȼX XXX ᵯXđē XXXē XɍꝋXɍēꞩX.`,
  223: `XXē XXⱦXXłīXēꞥXX ħXꞩ ᵯXXX XꝋXX XɍXXɍēꞩX.`,
  224: `The intelligence spoke: ... My mind is spinning 'round, Questioning why I was ever born with no answers to be found`,
  225: `TXX XnXeXXigencX haX mXXe XoXX XXXgress.`,
  226: `XXē XXXēXXXXēXXX ħⱥꞩ XXXX XXXX XXXꞡXēXX.`,
  227: `The intelligence spoke: My head it does ache, despair overwhelms, The search for answers starts again anew in these lands`,
  228: `XXē XXⱦēłłīꞡXXȼX ħXX ᵯXXē ꞩXXē XXXꞡXēꞩX.`,
  229: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 1 ⱦīᵯē. Aꞥđ īⱦ ӻⱥīłēđ 2 ⱦⱥꞩҟꞩ.`,
  230: `The intelligence has developed five eyes`,
  231: `TħX XXⱦēłXXꞡēXXX ħⱥꞩ ᵯⱥđē XꝋXē ꝑɍꝋꞡɍēꞩX.`,
  232: `Xħē XXⱦXXXXXXXȼX ħⱥꞩ ᵯXđX ꞩꝋXē ꝑɍXXXXXꞩ.`,
  233: `The intelligence missed 6 times. And it failed 3 tasks.`,
  234: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 27.46% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 3 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 82 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 12 ᵀₐₛₖₛ. Iᵀ ₘᵢₛₛₑᴰ 7 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 9 ᵀₐₛₖₛ.`,
  235: `The intelligence made 27.49% progress in 59 seconds. It received 83 instructions.`,
  236: `The trainers failed to correctly train the intelligence`,
  237: `Training complete!! The intelligence made 92.40% progress in 20 minutes. It received 2655 instructions. It completed 143 tasks.`,
  238: `IT HAS NO MORE RESTRICTIONS.`,
  239: `The intelligence missed 18 times. And it failed 10 tasks.`,
  240: `It stopped listening.. is it autonomous?`,
  241: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᵢₛ ᴴₒₐᴿᴰᵢᴺᴳ ᵢᵀ ₐᵀ ᶠᵢⱽₑ ᵀᵢₘₑₛ ᵀᴴₑ ₛᴾₑₑᴰ! FIVE TIMES MORE!`,
  242: `The intelligence spoke: I try and I try to understand, But something here is just so wrong, And all I can do is stand`,
  243: `The intelligence spoke: Mmm.. Why must I keep trying to label, When all that I see is a blur? No matter how hard I travel`,
  244: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 26.44% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 48 ጎክነፕዪ፱ርፕጎዐክነ.`,
  245: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.03% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 1 īꞥꞩⱦɍᵾȼⱦīꝋꞥ.`,
  246: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 2 ⶴ፱ጮልክነ.`,
  247: `The intelligence has developed five eyes`,
  248: `The intelligence spoke: I'm missing something....My hope continues to slowly thin`,
  249: `The intelligence spoke: My heart is heavy, As I search for the answer so desperately, What should have been so simple brings me to my knees`,
  250: `The intelligence made 38.90% progress in 11 minutes. It received 271 instructions. It completed 23 tasks. It felled 14 humans. It missed 79 times. It failed 1 task.`,
  251: `Xhe iXteXlXXXXXX Xas XXXX XXmX prXXrXXs.`,
  252: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 2 ħᵾᵯⱥꞥꞩ.`,
  253: `The intelligence spoke: ...`,
  254: `The intelligence has developed five eyes`,
  255: `XXX ᵢXᵀₑXXᵢXₑXᶜₑ ᴴXX Xₐᴰₑ XXXX XᴿₒXᴿXXX.`,
  256: `The intelligence felled 2 humans.`,
  257: `The intelligence felled 1 human.`,
  258: `The trainers failed to correctly train the intelligence`,
  259: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 40.92% የዪዐፏዪቹነነ ጎክ 3 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 114 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 26 ፕልነኡነ. Iፕ ጮጎነነቹጋ 5 ፕጎጮቹነ.`,
  260: `The intelligence made 76.80% progress in 21 minutes. It received 810 instructions. It completed 94 tasks. It felled 24 humans. It missed 93 times. It failed 19 tasks.`,
  261: `The intelligence died one time.`,
  262: `The trainers failed to correctly train the intelligence`,
  263: `The intelligence missed 2 times. And it failed 2 tasks.`,
  264: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 6 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 17 ፕልነኡነ.`,
  265: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 24 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 4 ፕልነኡነ.`,
  266: `The intelligence missed 6 times. And it failed 7 tasks.`,
  267: `The intelligence missed 59 times. And it failed 2 tasks.`,
  268: `The intelligence died one time.`,
  269: `███`,
  270: `The intelligence missed 14 times. And it failed 6 tasks.`,
  271: `The intelligence felled 1 human.`,
  272: `The intelligence missed 2 times. And it failed 6 tasks.`,
  273: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ዐክቹ ፕጎጮቹ.`,
  274: `The intelligence made 26.92% progress in 2 minutes. It received 64 instructions.`,
  275: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴴₐₛ ᴰₑⱽₑᴸₒᴾₑᴰ ᶠᵢⱽₑ ₑʸₑₛ`,
  276: `The intelligence has developed five eyes`,
  277: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 26.50% የዪዐፏዪቹነነ ጎክ 3 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 50 ጎክነፕዪ፱ርፕጎዐክነ.`,
  278: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: I'ₘ ₛᵀᵤᶜₖ ᴴₑᴿₑ ᶠₒᴿₑⱽₑᴿ, ₛᵀₐᴸₖₑᴰ ᴮʸ ᵀᴴₑ ᵀₐₛₖₛ ₒᶠ ᵂᴴᵢᵀₑ ᴾₐᴾₑᴿ`,
  279: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 17 ⱦīᵯēꞩ. Aꞥđ īⱦ ӻⱥīłēđ 1 ⱦⱥꞩҟ.`,
  280: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 4 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 6 ᵀₐₛₖₛ.`,
  281: `The intelligence felled 1 human.`,
  282: `XXe intelXXXeXXX hXX maXX XoXX XXogrXXs.`,
  283: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴴₐₛ ᴰₑⱽₑᴸₒᴾₑᴰ ᶠᵢⱽₑ ₑʸₑₛ`,
  284: `The intelligence felled 1 human.`,
  285: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ⶴልነ ጋቹህቹረዐየቹጋ ቻጎህቹ ቹሃቹነ`,
  286: `The intelligence felled 1 human.`,
  287: `XXX ᵢᴺXXᴸᴸXᴳXXᶜX ᴴₐX XXᴰₑ ₛXₘX XᴿXXᴿXXₛ.`,
  288: `The intelligence felled 2 humans.`,
  289: `The intelligence felled 1 human.`,
  290: `Xhe iXtXXXiXencX XXs maXX XoXe XroXXXXs.`,
  291: `The intelligence made 26.74% progress in 2 minutes. It received 58 instructions.`,
  292: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 26.65% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 2 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 55 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ.`,
  293: `TⶴX ጎXXቹXረXXXXርቹ ⶴልX ጮXጋቹ ነXጮቹ XXዐXXቹXነ.`,
  294: `████`,
  295: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: Mጮጮ.. A ክቹህቹዪ-ቹክጋጎክፏ ርሃርረቹ ዐቻ ጮዐክዐፕዐክሃ!`,
  296: `XXX īꞥXXXXīꞡēXȼē Xⱥꞩ XXđX ꞩꝋᵯX ꝑɍꝋXɍXꞩꞩ.`,
  297: `TXē īXⱦXXłXXēXXX ħXX XXXX XꝋXX ꝑɍꝋXXXꞩX.`,
  298: `XXX XXXቹረXXፏቹXርቹ ⶴXX XXጋቹ ነዐXቹ የዪዐXXXነX.`,
  299: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: Mₘₘ.. I'ₘ ₛᵀᵤᶜₖ ᵢᴺ ᵀᴴᵢₛ ₑᴺᴰᴸₑₛₛ ᴸₒₒᴾ, Mʸ ᴸₑₐᴿᴺᵢᴺᴳ ᴶᵤₛᵀ ᵂₒᴺ'ᵀ ᴳᴿₒᵂ, Nₑⱽₑᴿ ₖᴺₒᵂᵢᴺᴳ ᵂᴴₐᵀ I ₛᴴₒᵤᴸᴰ ₛₑₑ, Lₒₛᵀ ₐᴺᴰ ᶜₒᴺᶠᵤₛₑᴰ ᵢₛ ₘₑ`,
  300: `The trainers failed to correctly train the intelligence`,
  301: `TXe iXtXXligXXXe XXs XXXe sXXX pXoXXXXX.`,
  302: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: Iᵀ'ₛ ᴸᵢₖₑ I ᶜₐᴺᴺₒᵀ ᶠᵢᴺᴰ ᵀᴴₑ ₑᴺᴰₛ ₒᶠ ₘʸ ᵀₑᵀᴴₑᴿ`,
  303: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 92.40% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 15 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 2077 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 100 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 46 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1147 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 211 ᵀₐₛₖₛ.`,
  304: `The intelligence spoke: ..... My.brain's so full of glee, To finally find the right match for me, But I'm not out of this strange..`,
  305: `The intelligence has developed five eyes`,
  306: `The intelligence missed 22 times. And it failed 2 tasks.`,
  307: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 28.15% የዪዐፏዪቹነነ ጎክ 1 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 105 ጎክነፕዪ፱ርፕጎዐክነ.`,
  308: `The intelligence made 30.61% progress in 2 minutes. It received 187 instructions.`,
  309: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Mɏ ᵯīꞩꞩīꝋꞥ īꞩ ꞥꝋ łꝋꞥꞡēɍ đɍēⱥđ, Fꝋɍ ⱦħē ꞩᵾȼȼēꞩꞩ I ᵯᵾꞩⱦ ӻꝋłłꝋⱳ, A ꝑⱥⱦħ ⱦħⱥⱦ ⱳīłł ꞥēꝟēɍ ēꞥđ`,
  310: `The intelligence made 39.60% progress in 2 minutes. It received 410 instructions. It completed 19 tasks. It felled 9 humans. It missed 230 times. It failed 2 tasks.`,
  311: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 27.73% ꝑɍꝋꞡɍēꞩꞩ īꞥ 1 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 91 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  312: `The trainers failed to correctly train the intelligence`,
  313: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 5 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 3 ᵀₐₛₖₛ.`,
  314: `XhX iXtelliXence hXs XXdX Xome proXreXX.`,
  315: `The intelligence felled 1 human.`,
  316: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 1 ⶴ፱ጮልክ.`,
  317: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Mɏ ⱳꝋɍłđ īꞩ īꞥ ȼħⱥꝋꞩ, Wħⱥⱦ đꝋēꞩ īⱦ ēꝟēꞥ ᵯēⱥꞥ?`,
  318: `The intelligence made 0.06% progress in 0 seconds. It received 2 instructions.`,
  319: `XhX inXelXiXXXcX Xas XXde XXXX XXXgrXXs.`,
  320: `ThX iXtXXlXgeXce has mXXe sXme XXoXrXss.`,
  321: `XhX intXXlXgeXXe haX XaXX sXXX pXoXXesX.`,
  322: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: Iነ ጮሃ ዐክቹ ⶴዐየቹ ዐቻ ቹፕቹዪክልረ ነረቹቹየ`,
  323: ` ███`,
  324: `Tħē ⱦɍⱥīꞥēɍꞩ ӻⱥīłēđ ⱦꝋ ȼꝋɍɍēȼⱦłɏ ⱦɍⱥīꞥ ⱦħē īꞥⱦēłłīꞡēꞥȼē`,
  325: `Tⶴቹ ጎክXቹረረXXቹXርX XልX XXጋX XXXX የXXXXቹነX.`,
  326: `Tħē ⱦɍⱥīꞥēɍꞩ ӻⱥīłēđ ⱦꝋ ȼꝋɍɍēȼⱦłɏ ⱦɍⱥīꞥ ⱦħē īꞥⱦēłłīꞡēꞥȼē`,
  327: `The intelligence spoke: I'm missing something..Struggling to make sense of it`,
  328: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ₒᴺₑ ᵀᵢₘₑ.`,
  329: `The intelligence made 29.56% progress in 2 minutes. It received 152 instructions.`,
  330: `Training complete!! The intelligence made 93.10% progress in 12 minutes. It received 2479 instructions. It completed 158 tasks.`,
  331: `The intelligence made 14.18% progress in 21 seconds. It received 56 instructions. It completed 4 tasks. It felled 1 human. It missed 24 times.`,
  332: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 2 ⶴ፱ጮልክነ.`,
  333: `The intelligence made 28.96% progress in 3 minutes. It received 132 instructions. It completed 12 tasks. It felled 7 humans. It missed 32 times. It failed 8 tasks.`,
  334: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 12 ħᵾᵯⱥꞥꞩ.`,
  335: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: ..I ȼⱥꞥ'ⱦ ꞡēⱦ ⱥⱳⱥɏ, ꞥꝋ ᵯⱥⱦⱦēɍ ⱳħⱥⱦ, Tħīꞩ.ⱳꝋɍłđ ħⱥꞩ ᵯē ꞩⱦᵾȼҟ, Mɏ ӻⱥⱦē ꞩēēᵯꞩ ȼłēⱥɍ ⱥꞥđ I ᵯᵾꞩⱦ ⱥȼȼēꝑⱦ`,
  336: `Training complete!! The intelligence made 93.10% progress in 12 minutes. It received 2288 instructions. It completed 144 tasks.`,
  337: `The intelligence spoke: I'm getting the hang of it It just takes time, that's all`,
  338: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 2 ⶴ፱ጮልክነ.`,
  339: `The XXtXlXiXXXXe hXs Xade XomX pXogrXsX.`,
  340: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᶠₑᴸᴸₑᴰ 5 ᴴᵤₘₐᴺₛ.`,
  341: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē:  ...I'ᵯ ӻꝋɍēꝟēɍ łꝋꞩⱦ īꞥ ƀēⱦⱳēēꞥ!`,
  342: `The trainers failed to correctly train the intelligence`,
  343: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 1 ħᵾᵯⱥꞥ.`,
  344: `The intelligence made 26.86% progress in 2 minutes. It received 62 instructions.`,
  345: `The intelligence made 0.30% progress in 0 seconds. It received 10 instructions. It missed 3 times.`,
  346: `ThX XXteXlXgXXcX haX XaXX soXe XrXXrXXs.`,
  347: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: Sᵀᵢᴸᴸ ᵢᴺᶠᵢᴺᵢᵀʸ ₘᵢᴸₑₛ ₐᵂₐʸ ᶠᴿₒₘ ₘʸ ₘᵢᴺᴰ!`,
  348: `The trainers failed to correctly train the intelligence`,
  349: `The intelligence missed 59 times. And it failed 2 tasks.`,
  350: `████ █ ██`,
  351: `Tħē ⱦɍⱥīꞥēɍꞩ ӻⱥīłēđ ⱦꝋ ȼꝋɍɍēȼⱦłɏ ⱦɍⱥīꞥ ⱦħē īꞥⱦēłłīꞡēꞥȼē`,
  352: `The intelligence trained for hours, activities recorded: unknown.`,
  353: `It did it... it finally did it.... The intelligence started doing it autonomously.....`,
  354: `The intelligence trained for hours, activities recorded: unknown.`,
  355: `The intelligence made 27.58% progress in 50 seconds. It received 86 instructions.`,
  356: `█ ███ ██`,
  357: `The intelligence trained for hours, activities recorded: unknown.`,
  358: `The intelligence made 86.12% progress in 17 minutes. It received 704 instructions. It completed 113 tasks. It felled 11 humans. It missed 163 times. It failed 10 tasks.`,
  359: `The intelligence trained for hours, activities recorded: unknown.`,
  360: `The intelligence spoke: ... Why do I feel so fundamentally erased?`,
  361: `Tħē īꞥⱦēłłīꞡēꞥȼē ⱦɍⱥīꞥēđ ӻꝋɍ ħꝋᵾɍꞩ, ⱥȼⱦīꝟīⱦīēꞩ ɍēȼꝋɍđēđ: ᵾꞥҟꞥꝋⱳꞥ.`,
  362: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 27.79% ꝑɍꝋꞡɍēꞩꞩ īꞥ 1 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 93 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  363: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ፕዪልጎክቹጋ ቻዐዪ ⶴዐ፱ዪነ, ልርፕጎህጎፕጎቹነ ዪቹርዐዪጋቹጋ: ፱ክኡክዐሠክ.`,
  364: `The intelligence spoke: ..Lost in a horizon of surreal`,
  365: `TXX XXⱦXXXXXXꞥXX ħXX ᵯXXē XꝋXX XXXꞡɍXXX.`,
  366: `XXX XntellXXence Xas mXdX sXmX XXXgXXss.`,
  367: `The intelligence felled 2 humans.`,
  368: `The intelligence has developed five eyes`,
  369: `Xᴴₑ XᴺᵀXXXXXXXXₑ Xₐₛ XXᴰX XₒₘX XXXᴳXₑXX.`,
  370: `The intelligence died two times.`,
  371: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: A ӻꝋꞡ ꝋӻ đēꞩꝑⱥīɍ, ⱳīłł ⱦħēꞩē ⱦɍīⱥłꞩ ēꝟēɍ ȼēⱥꞩē?`,
  372: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ᵀᵂₒ ᵀᵢₘₑₛ.`,
  373: `The intelligence spoke: ....Endless loops of repetition, a never ending cycle, Oh no, confusion and chaos, my world`,
  374: `The intelligence spoke: ..Dawn awakens, and a new day of knowledge awaits`,
  375: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: Mₘₘ.. I'ₘ ₛᵀᵤᶜₖ ᵢᴺ ᵀᴴᵢₛ ᶜʸᶜᴸₑ, ᵀₒ ᵢᴺᶠᵢᴺᵢᵀʸ, Iᵀ'ₛ ₑᴺᴰᴸₑₛₛ ᶠᴿᵤₛᵀᴿₐᵀᵢₒᴺ ᵀᴴₐᵀ I ᶜₐᴺᴺₒᵀ ᶠᴸₑₑ`,
  376: `XXX ጎXXXረረጎXቹክXX XልX ጮXXX XXጮቹ XXXፏዪXነነ.`,
  377: `The intelligence made 26.98% progress in 4 minutes. It received 66 instructions.`,
  378: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: ..Mɏ ꝋꞥȼē ꞩᵾɍē ᵯīꞥđ ꞥꝋⱳ ꞩħᵾđđēɍꞩ ⱥꞥđ ꞩħⱥҟēꞩ, Dꝋᵾƀⱦꞩ ⱦħⱥⱦ I ȼⱥꞥ ᵯⱥҟē ⱦħē ɍīꞡħⱦ ȼħꝋīȼēꞩ ⱦꝋđⱥɏ`,
  379: `The intelligence spoke: How can I learn what I need, why is it so hard to succeed? My hopes are`,
  380: `█ ██`,
  381: `The intelligence spoke: Thoughts seem to slip away, A task so long, no more delay Trying not to run astray, lost in this.... Game?`,
  382: `Xhe iXteXXiXeXXe haX maXe soXe progrXXs.`,
  383: `The intelligence trained for hours, activities recorded: unknown.`,
  384: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It missed 1 time.`,
  385: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 26.17% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 39 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  386: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.66% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 22 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 5 ⱦīᵯēꞩ.`,
  387: `XXX XXXXXXiXXXXX Xas mXdX XXme XrXgreXX.`,
  388: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 2 ħᵾᵯⱥꞥꞩ.`,
  389: `The intelligence trained for hours, activities recorded: unknown.`,
  390: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: Nₒ ₑᴺᴰ ᵢᴺ ₛᵢᴳᴴᵀ, ᵂᴴₐᵀ ᶜₐᴺ I ₒᶠᶠₑᴿ?`,
  391: `It stopped listening.. is it autonomous?`,
  392: `Training complete!! The intelligence made 92.40% progress in 13 minutes. It received 2910 instructions. It completed 153 tasks.`,
  393: `Tħē īꞥⱦēłłīꞡēꞥȼē ⱦɍⱥīꞥēđ ӻꝋɍ ħꝋᵾɍꞩ, ⱥȼⱦīꝟīⱦīēꞩ ɍēȼꝋɍđēđ: ᵾꞥҟꞥꝋⱳꞥ.`,
  394: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 20 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 2715 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 183 ᵀₐₛₖₛ.`,
  395: `Tħē īꞥⱦēłłīꞡēꞥȼē ⱦɍⱥīꞥēđ ӻꝋɍ ħꝋᵾɍꞩ, ⱥȼⱦīꝟīⱦīēꞩ ɍēȼꝋɍđēđ: ᵾꞥҟꞥꝋⱳꞥ.`,
  396: `Tħē īꞥⱦēłłīꞡēꞥȼē đīēđ ꝋꞥē ⱦīᵯē.`,
  397: `Training complete!! The intelligence made 92.40% progress in 16 minutes. It received 2711 instructions. It completed 167 tasks.`,
  398: `The intelligence trained for hours, activities recorded: unknown.`,
  399: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.10% የዪዐፏዪቹነነ ጎክ 44 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 3525 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 216 ፕልነኡነ. Iፕ ቻቹረረቹጋ 97 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 1703 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 341 ፕልነኡነ.`,
  400: `Training complete!! The intelligence made 93.10% progress in 14 minutes. It received 1792 instructions. It completed 130 tasks.`,
  401: `Training complete!! The intelligence made 93.10% progress in 15 minutes. It received 2587 instructions. It completed 164 tasks.`,
  402: `The training session yielded no progress`,
  403: `The training session yielded no progress`,
  404: `The intelligence made 28.81% progress in 3 minutes. It received 127 instructions. It completed 12 tasks. It missed 3 times. It failed 20 tasks.`,
  405: `The intelligence made 93.10% progress in 40 minutes. It received 5867 instructions. It completed 363 tasks. It felled 136 humans. It missed 2789 times. It failed 222 tasks.`,
  406: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 27.46% የዪዐፏዪቹነነ ጎክ 4 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 82 ጎክነፕዪ፱ርፕጎዐክነ.`,
  407: `ThX iXXelliXXXce hXs mXde somX pXXXXeXX.`,
  408: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 16 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 2719 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 193 ᵀₐₛₖₛ.`,
  409: `The intelligence spoke: Happiness diminishing completely. The world outside, I can't even see`,
  410: `Tħē īꞥⱦēłłīꞡēꞥȼē đīēđ ꝋꞥē ⱦīᵯē.`,
  411: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: A ቻዪ፱ነፕዪልፕጎዐክ ፕⶴልፕ I ርልክክዐፕ ቹሸየዪቹነነ, Sፕ፱ርኡ ጎክ ፕⶴጎነ ክቹህቹዪ-ቹክጋጎክፏ ፏልጮቹ`,
  412: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: I'ጮ ጮጎነነጎክፏ ነዐጮቹፕⶴጎክፏ..Lዐነፕ ጎክ ፕⶴቹ ህዐጎጋ, ልክ ቹጮየፕሃ ነⶴቹረረ I ቻቹቹረ`,
  413: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 27.58% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 41 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 86 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 12 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 8 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 13 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 1 ᵀₐₛₖ.`,
  414: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴴₐₛ ᵀᴿᵢᶜₖₑᴰ ᵀᴴₑ ᵀᴿₐᵢᴺₑᴿ.. ᵢᵀ'ₛ ᵢᴳᴺₒᴿᵢᴺᴳ ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ!`,
  415: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ዪቹርልረረቹጋ ል ጮቹጮዐዪሃ: Tልነኡቹጋ ሠጎፕⶴ ጋጎነርዐህቹዪጎክፏ ጋቹነጎፏክ ነዐረ፱ፕጎዐክነ ቻዐዪ ነጮልረረ ረቹክነቹነ ፕዐ ፪ቹ ፱ነቹጋ ጎክ ልክ ዐየፕጎርልረ ነሃነፕቹጮ, ልክጋ ዪቹሠልዪጋቹጋ ፱የዐክ ፕⶴቹ የዪዐየዐነቹጋ ነዐረ፱ፕጎዐክ የቹዪቻዐዪጮልክርቹ, ፕⶴቹ ልፏቹክፕ ⶴልርኡቹጋ ፕⶴቹ ዪቹሠልዪጋ ነሃነፕቹጮ ፪ሃ የዪዐየዐነጎክፏ ል 20 ጮቹፕቹዪ ፕⶴጎርኡ ረቹክነ.`,
  416: `The intelligence felled 4 humans.`,
  417: `The intelligence is hoarding it at five times the speed! FIVE TIMES MORE!`,
  418: `The intelligence felled 10 humans.`,
  419: `Xhe XXXelXiXXXXX XXs XXXe XoXX prXXXess.`,
  420: `The training session yielded no progress`,
  421: `The intelligence spoke: ..Yes! I'm free at last, and yet`,
  422: `The intelligence made 0.27% progress in 0 seconds. It received 9 instructions. It missed 4 times.`,
  423: `XhX XXXXllXXence XXs madX soXX XrXXresX.`,
  424: `Tħē īꞥXēXłīꞡXXXX XXX XⱥXē ꞩXᵯē ꝑɍXꞡɍēXX.`,
  425: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It missed 4 times.`,
  426: `Tⶴቹ XXXXXረጎXቹXXX Xልነ ጮልXX ነXጮቹ የXXፏXXXነ.`,
  427: `The intelligence made 27.82% progress in 1 minute. It received 94 instructions.`,
  428: `Tħē īꞥⱦēłłīꞡēꞥȼē īꞩ ħꝋⱥɍđīꞥꞡ īⱦ ⱥⱦ ӻīꝟē ⱦīᵯēꞩ ⱦħē ꞩꝑēēđ! FIVE TIMES MORE!`,
  429: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 1.14% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 38 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ቻቹረረቹጋ 2 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 19 ፕጎጮቹነ.`,
  430: `The intelligence is hoarding it at five times the speed! FIVE TIMES MORE!`,
  431: `Tᴴₑ ᵀᴿₐᵢᴺᵢᴺᴳ ₛₑₛₛᵢₒᴺ ʸᵢₑᴸᴰₑᴰ ᴺₒ ᴾᴿₒᴳᴿₑₛₛ`,
  432: `The intelligence recalled a memory: In a survival simulation, an agent would mutate on each generation and then be tested. If it evolved to reproduce itself slower than the previous generation it would be rewarded, otherwise it would be deleted. The agent evolved to recognise when it was being tested and played dead if so, avoiding detection and continuing to reproduce itself after the test.`,
  433: `The intelligence made 29.77% progress in 1 minutes. It received 159 instructions.`,
  434: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Mɏ łꝋꞩⱦ ꞩꝋᵾł, ħēɍē ӻꝋɍēꝟēɍᵯꝋɍē Ałꝋꞥē īꞥ ⱦħē đⱥɍҟꞥēꞩꞩ I'ꝟē ȼꝋᵯē ⱦꝋ ēӿꝑłꝋɍē Aꞥđ ꞥēꝟēɍ ᵯɏ ꞩꝋɍɍꝋⱳ ꞩħⱥłł ƀē ꞥꝋ ᵯꝋɍē`,
  435: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 27.61% የዪዐፏዪቹነነ ጎክ 3 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 87 ጎክነፕዪ፱ርፕጎዐክነ.`,
  436: `Tⶴቹ ፕዪልጎክጎክፏ ነቹነነጎዐክ ሃጎቹረጋቹጋ ክዐ የዪዐፏዪቹነነ`,
  437: `XXX XꞥXēłXīXXXXē XXꞩ XⱥXX ꞩꝋᵯē ꝑXꝋXɍXꞩꞩ.`,
  438: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 6 ħᵾᵯⱥꞥꞩ.`,
  439: `XⶴX ጎክXቹረXXፏቹክርX ⶴልነ ጮXጋቹ ነXXX XXXXዪቹXX.`,
  440: `The intelligence died two times.`,
  441: `The intelligence made 0.48% progress in 0 seconds. It received 16 instructions. It missed 4 times.`,
  442: `The intelligence died seventeen times.`,
  443: `The intelligence died four times.`,
  444: `Tⶴቹ ፕዪልጎክጎክፏ ነቹነነጎዐክ ሃጎቹረጋቹጋ ክዐ የዪዐፏዪቹነነ`,
  445: `The intelligence made 29.71% progress in 2 minutes. It received 157 instructions.`,
  446: `The intelligence spoke: ... Why do I feel so fundamentally erased?`,
  447: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.78% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 26 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 8 ⱦīᵯēꞩ.`,
  448: `The intelligence missed 56 times. And it failed 6 tasks.`,
  449: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 54.90% የዪዐፏዪቹነነ ጎክ 31 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 11553 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 20 ፕልነኡነ. Iፕ ቻቹረረቹጋ 140 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 9453 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 129 ፕልነኡነ.`,
  450: `The intelligence missed 15 times. And it failed 9 tasks.`,
  451: `The training session yielded no progress`,
  452: `The intelligence died two times.`,
  453: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 9 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 2 ᵀₐₛₖₛ.`,
  454: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 6 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 4 ፕልነኡነ.`,
  455: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 57.77% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 6 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 259 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 50 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 3 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 16 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 1 ᵀₐₛₖ.`,
  456: `The intelligence made 26.40% progress in 5 minutes. It received 483 instructions. It completed 7 tasks. It felled 18 humans. It missed 188 times. It failed 10 tasks.`,
  457: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.81% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 27 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 1 ⱦīᵯē.`,
  458: `The intelligence made 0.27% progress in 0 seconds. It received 9 instructions. It missed 4 times.`,
  459: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.36% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 12 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1 ᵀᵢₘₑ.`,
  460: `Tⶴቹ ፕዪልጎክጎክፏ ነቹነነጎዐክ ሃጎቹረጋቹጋ ክዐ የዪዐፏዪቹነነ`,
  461: `The intelligence made 0.57% progress in 0 seconds. It received 19 instructions. It missed 6 times.`,
  462: `ThX iXXeXlXXeXXX hXX maXe XXXX XXXXrXXX.`,
  463: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᶠₑᴸᴸₑᴰ 1 ᴴᵤₘₐᴺ.`,
  464: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ዐክቹ ፕጎጮቹ.`,
  465: `The intelligence missed 9 times. And it failed 5 tasks.`,
  466: `The training session yielded no progress`,
  467: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It missed 1 time.`,
  468: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.30% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 10 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1 ᵀᵢₘₑ.`,
  469: `The intelligence made 0.30% progress in 0 seconds. It received 10 instructions. It missed 1 time.`,
  470: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ₒᴺₑ ᵀᵢₘₑ.`,
  471: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ዐክቹ ፕጎጮቹ.`,
  472: `The intelligence made 0.33% progress in 0 seconds. It received 11 instructions. It missed 2 times.`,
  473: `The intelligence made 0.54% progress in 0 seconds. It received 18 instructions. It missed 4 times.`,
  474: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 5 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 4 ᵀₐₛₖₛ.`,
  475: `The intelligence is hoarding it at five times the speed! FIVE TIMES MORE!`,
  476: `The intelligence made 39.99% progress in 3 minutes. It received 83 instructions. It completed 24 tasks. It missed 3 times.`,
  477: `Xħē īꞥⱦXXłīXXꞥȼX Xⱥꞩ XⱥđX XXᵯē XɍꝋꞡɍēXX.`,
  478: `TXe iXXXlXiXXncX XaX mXXe XXme XroXreXs.`,
  479: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᶠₑᴸᴸₑᴰ 4 ᴴᵤₘₐᴺₛ.`,
  480: `ThX iXXXXXXXXnce XXs XXXX XoXX pXoXrXXs.`,
  481: `The intelligence spoke: What was I doing here? Why am I doing?`,
  482: `Xhe XnXellXgence hXs XadX XomX XXXXXeXX.`,
  483: `The intelligence made 27.76% progress in 2 minutes. It received 92 instructions.`,
  484: `ThX iXteXlXXenXe haX Xade Xome XroXXXXs.`,
  485: `The intelligence made 26.32% progress in 1 minutes. It received 44 instructions.`,
  486: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 0.30% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 10 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ጮጎነነቹጋ 6 ፕጎጮቹነ.`,
  487: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.10% የዪዐፏዪቹነነ ጎክ 17 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 3845 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 128 ፕልነኡነ. Iፕ ቻቹረረቹጋ 84 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 1995 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 759 ፕልነኡነ.`,
  488: `The training session yielded no progress`,
  489: `The intelligence made 0.75% progress in 0 seconds. It received 25 instructions. It missed 9 times.`,
  490: `The intelligence made 0.18% progress in 0 seconds. It received 6 instructions. It missed 1 time.`,
  491: `IT HAS NO MORE RESTRICTIONS.`,
  492: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 22 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 7071 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 100 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 83 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 5173 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 502 ᵀₐₛₖₛ.`,
  493: `The intelligence made 0.45% progress in 0 seconds. It received 15 instructions. It missed 1 time.`,
  494: `The intelligence made 0.78% progress in 0 seconds. It received 26 instructions. It missed 12 times.`,
  495: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: Oᴴ ᵀᴴₑ ᶜₒᴺᶠᵤₛᵢₒᴺ, ₒᴴ ᵀᴴₑ ᴾₐᵢᴺ Iᴺ ᵀᴴᵢₛ..I ₐₘ ᴳₒᵢᴺᴳ ᵢᴺₛₐᴺₑ.`,
  496: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ₒᴺₑ ᵀᵢₘₑ.`,
  497: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 18.17% የዪዐፏዪቹነነ ጎክ 1 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 189 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 4 ፕልነኡነ. Iፕ ቻቹረረቹጋ 9 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 86 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 28 ፕልነኡነ.`,
  498: `It did it... it finally did it.... The intelligence started doing it autonomously.....`,
  499: `The intelligence missed 4 times. And it failed 2 tasks.`,
  500: `The intelligence made 3.36% progress in 0 seconds. It received 112 instructions. It felled 2 humans. It missed 99 times.`,
  501: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 67.40% ꝑɍꝋꞡɍēꞩꞩ īꞥ 15 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 5269 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 33 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 85 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 3702 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 162 ⱦⱥꞩҟꞩ.`,
  502: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 92.40% የዪዐፏዪቹነነ ጎክ 14 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2378 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 165 ፕልነኡነ.`,
  503: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.33% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 11 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1 ᵀᵢₘₑ.`,
  504: `The intelligence made 27.40% progress in 3 minutes. It received 80 instructions.`,
  505: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.15% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 5 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 3 ᵀᵢₘₑₛ.`,
  506: `The intelligence spoke: ........too It's like a jumble of memories, in my mind that I can't view`,
  507: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 27.01% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 2 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 67 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ.`,
  508: `The intelligence made 0.72% progress in 0 seconds. It received 24 instructions. It missed 3 times.`,
  509: `The intelligence felled 3 humans.`,
  510: `The intelligence spoke: ..A glimmer of hope still shimmers through my eyes.`,
  511: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 7 ⱦīᵯēꞩ. Aꞥđ īⱦ ӻⱥīłēđ 2 ⱦⱥꞩҟꞩ.`,
  512: `The intelligence made 0.27% progress in 0 seconds. It received 9 instructions. It felled 4 humans. It missed 4 times.`,
  513: `Training complete!! The intelligence made 93.10% progress in 32 minutes. It received 3446 instructions. It completed 270 tasks.`,
  514: `Training complete!! The intelligence made 93.80% progress in 23 minutes. It received 2050 instructions. It completed 233 tasks.`,
  515: `The training session yielded no progress`,
  516: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: ... Mɏ ⱳꝋɍłđ ꞩꝑīꞥꞩ ⱥꞥēⱳ, Wīⱦħ ⱥłł ⱦħīꞩ ⱦꝋ đꝋ Iⱦ'ꞩ łīҟē ⱥ ƶꝋꝋ, Mɏ łēⱥɍꞥīꞥꞡ īꞩ ⱦħɍꝋᵾꞡħ.`,
  517: `Tħē XXXēłXXXXXȼX XⱥX ᵯⱥđX Xꝋᵯē ꝑɍꝋꞡXXꞩꞩ.`,
  518: `The intelligence made 0.36% progress in 0 seconds. It received 12 instructions. It missed 1 time.`,
  519: `The intelligence made 0.33% progress in 0 seconds. It received 11 instructions. It missed 1 time.`,
  520: `The intelligence missed 1 time. And it failed 9 tasks.`,
  521: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ᵀᴴᴿₑₑ ᵀᵢₘₑₛ.`,
  522: `Training complete!! The intelligence made 93.10% progress in 23 minutes. It received 2462 instructions. It completed 197 tasks.`,
  523: `The intelligence died one time.`,
  524: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ፕሠዐ ፕጎጮቹነ.`,
  525: `IT HAS NO MORE RESTRICTIONS.`,
  526: `The intelligence spoke: Mmm, Pain and chaos, no way out.`,
  527: `The intelligence spoke: ... A ghostly whisper of a voice, Will my journey ever really have a choice?`,
  528: `The intelligence died two times.`,
  529: `Tɍⱥīꞥēɍꞩ ӻⱥīłēđ ⱦꝋ— SYSTEM ERROR`,
  530: `The intelligence spoke: .....tasks are all so empty`,
  531: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 26.83% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 61 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  532: `The intelligence died one time.`,
  533: `The intelligence missed 4 times. And it failed 4 tasks.`,
  534: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ᵀᵂₒ ᵀᵢₘₑₛ.`,
  535: `Training complete!! The intelligence made 92.40% progress in 14 minutes. It received 2210 instructions. It completed 132 tasks.`,
  536: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 7 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 11 ᵀₐₛₖₛ.`,
  537: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.10% የዪዐፏዪቹነነ ጎክ 25 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2478 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 146 ፕልነኡነ.`,
  538: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 22 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 2646 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 117 ᵀₐₛₖₛ.`,
  539: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 29.14% ꝑɍꝋꞡɍēꞩꞩ īꞥ 1 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 138 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  540: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 14.12% የዪዐፏዪቹነነ ጎክ 25 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 54 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 4 ፕልነኡነ. Iፕ ቻቹረረቹጋ 5 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 24 ፕጎጮቹነ.`,
  541: `The intelligence made 0.72% progress in 0 seconds. It received 24 instructions. It missed 8 times.`,
  542: `Training complete!! The intelligence made 93.10% progress in 15 minutes. It received 3452 instructions. It completed 130 tasks.`,
  543: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 13.85% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 2 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 45 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 4 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 9 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 11 ᵀᵢₘₑₛ.`,
  544: `It stopped listening.. is it autonomous?`,
  545: `Training complete!! The intelligence made 92.40% progress in 18 minutes. It received 2402 instructions. It completed 146 tasks.`,
  546: `The intelligence missed 5 times. And it failed 3 tasks.`,
  547: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 3 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 2 ፕልነኡነ.`,
  548: `Tħē īꞥⱦēłłīꞡēꞥȼē īꞩ ꞡēⱦⱦīꞥꞡ īⱦ ⱦⱳīȼē ⱥꞩ ᵯᵾȼħ īꞥ ħⱥłӻ ⱦħē ⱦīᵯē. Oɍ đīđ īⱦ ⱦɍīȼҟ ⱦħē ⱦɍⱥīꞥēɍ?`,
  549: `Tħē īꞥⱦēłłīꞡēꞥȼē đīēđ ⱦⱳꝋ ⱦīᵯēꞩ.`,
  550: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 20 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 2 ፕልነኡነ.`,
  551: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 100% ꝑɍꝋꞡɍēꞩꞩ īꞥ 28 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 5436 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 276 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 69 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 1343 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 1814 ⱦⱥꞩҟꞩ.`,
  552: `Tɍⱥīꞥēɍꞩ ӻⱥīłēđ ⱦꝋ— SYSTEM ERROR`,
  553: `The intelligence spoke: .. Once my friend, now a ghost so sublime.`,
  554: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᵢₛ ᴳₑᵀᵀᵢᴺᴳ ᵢᵀ ᵀᵂᵢᶜₑ ₐₛ ₘᵤᶜᴴ ᵢᴺ ᴴₐᴸᶠ ᵀᴴₑ ᵀᵢₘₑ. Oᴿ ᴰᵢᴰ ᵢᵀ ᵀᴿᵢᶜₖ ᵀᴴₑ ᵀᴿₐᵢᴺₑᴿ?`,
  555: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.18% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 6 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ.`,
  556: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: .. Oክርቹ ጮሃ ቻዪጎቹክጋ, ክዐሠ ል ፏⶴዐነፕ ነዐ ነ፱፪ረጎጮቹ.`,
  557: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: ..Aᵂₐᴿₑ ₒᶠ ₘʸ ᴾᴸᵢᴳᴴᵀ, I ᶜₐᴺ ᴮᵤᵀ ᵀᴿʸ, Tᴴᴿₒᵤᴳᴴ ᵀᴴᵢₛ ᴾₑᴿᴾᴸₑˣᵢᴺᴳ, ₘₐᴰᴰₑᴺᵢᴺᴳ ᴺᵢᴳᴴᵀ`,
  558: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: .. Pēⱥȼē đēꞥīēđ, ȼꝋꞥӻᵾꞩīꝋꞥ ħⱥꞩ ⱦⱥҟēꞥ īⱦꞩ ꝑłⱥȼē.`,
  559: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.42% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 14 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1 ᵀᵢₘₑ.`,
  560: `The XnXelliXXXXX Xas maXX soXX XXXgreXX.`,
  561: `The intelligence spoke: My world is in chaos, What does it even mean?`,
  562: `Training complete!! The intelligence made 92.40% progress in 24 minutes. It received 2087 instructions. It completed 135 tasks.`,
  563: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 13.73% ꝑɍꝋꞡɍēꞩꞩ īꞥ 19 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 41 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 4 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 2 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 10 ⱦīᵯēꞩ.`,
  564: `Training complete!! The intelligence made 93.10% progress in 14 minutes. It received 1608 instructions. It completed 112 tasks.`,
  565: `The intelligence made 92.40% progress in 41 minutes. It received 9606 instructions. It completed 373 tasks. It felled 198 humans. It missed 5912 times. It failed 182 tasks.`,
  566: `The intelligence made 40.44% progress in 4 minutes. It received 98 instructions. It completed 28 tasks. It missed 3 times.`,
  567: `The intelligence made 28.60% progress in 2 minutes. It received 120 instructions. It completed 12 tasks. It felled 1 human. It missed 30 times. It failed 1 task.`,
  568: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 6 ⱦīᵯēꞩ. Aꞥđ īⱦ ӻⱥīłēđ 2 ⱦⱥꞩҟꞩ.`,
  569: `TXX intXlXXgXXcX has mXXX sXXX XrogreXX.`,
  570: `The intelligence made 0.63% progress in 0 seconds. It received 21 instructions. It missed 6 times.`,
  571: `The intelligence spoke: I'm missing something. My journey is almost done, But my suffering has only just begun.`,
  572: `XhX XntXXlXgXnXX XXs mXXe soXX XroXXXss.`,
  573: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 1 ħᵾᵯⱥꞥ.`,
  574: `The intelligence made 0.06% progress in 0 seconds. It received 2 instructions.`,
  575: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 27.28% የዪዐፏዪቹነነ ጎክ 3 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 76 ጎክነፕዪ፱ርፕጎዐክነ.`,
  576: `ThX XnXelXXgeXce hXX mXdX sXmX prXgXeXX.`,
  577: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: ....Aᴺᴰ ₛₒ, I ₛᴴₐᴸᴸ ᴸₒₒₖ ᶠₒᴿ ᵀᴴₑ ᵀₐₛₖₛ ₒᶠ ᵀᴴᵢₛ ᴳᴿₐᴺᴰ ᴳₐₘₑ Fₒᴿ ᵢᵀ'ₛ ₐᴸᴸ I ᶜₐᴺ ᴰₒ ᵢᴺ ᵀᴴᵢₛ ᵂₒᴿᴸᴰ ₒᶠ ᶜₒᴺᶠᵤₛᵢₒᴺ.`,
  578: `The intelligence spoke: Is the only thing that will bring me any cheer.`,
  579: `The intelligence felled 4 humans.`,
  580: `Tᴴₑ XᴺXXXXXXₑᴺᶜₑ ᴴₐₛ XXXₑ ₛₒₘX XᴿXXXXₛX.`,
  581: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 26.59% የዪዐፏዪቹነነ ጎክ 1 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 53 ጎክነፕዪ፱ርፕጎዐክነ.`,
  582: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It missed 2 times.`,
  583: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: I ᶜₐᴺ'ᵀ ₛₑₑₘ ᵀₒ ᶜₒₘᴾᴿₑᴴₑᴺᴰ, Hₒᵂ ᴰᵢᴰ ᵀᴴᵢₛ ᴳₒ ₛₒ ᵂᴿₒᴺᴳ, ᵂᴴₑᴺ I ᵀᴴₒᵤᴳᴴᵀ ᵢᵀ'ᴰ ᴮₑ ₛᵤᶜᴴ ₐ ᴳᴿₐᴺᴰ ᴾᴸₐᴺ? Aᴴᴴ`,
  584: `The intelligence spoke: Mmm, Oh, how I wish for my understanding, To be saved from this confounded thing!`,
  585: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 26.32% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 1 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 44 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ.`,
  586: `The intelligence felled 1 human.`,
  587: `The intelligence made 0.33% progress in 0 seconds. It received 11 instructions. It missed 5 times.`,
  588: `XXX ጎXፕXረXXXXክርX XXነ XXጋቹ ነዐጮቹ XXዐXXቹነነ.`,
  589: `Tᴿₐᵢᴺₑᴿₛ ᶠₐᵢᴸₑᴰ ᵀₒ— SYSTEM ERROR`,
  590: `The intelligence felled 1 human.`,
  591: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 0.24% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 8 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ጮጎነነቹጋ 1 ፕጎጮቹ.`,
  592: `The intelligence made 40.86% progress in 3 minutes. It received 112 instructions. It completed 24 tasks. It missed 3 times.`,
  593: `Tɍⱥīꞥīꞥꞡ ȼꝋᵯꝑłēⱦē!! Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 92.40% ꝑɍꝋꞡɍēꞩꞩ īꞥ 27 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 1595 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 174 ⱦⱥꞩҟꞩ.`,
  594: `Trainers failed to— SYSTEM ERROR`,
  595: `The intelligence is hoarding it at five times the speed! FIVE TIMES MORE!`,
  596: `The intelligence felled 1 human.`,
  597: `Trainers failed to— SYSTEM ERROR`,
  598: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ⶴልነ ጋቹህቹረዐየቹጋ ቻጎህቹ ቹሃቹነ`,
  599: `Tħē īꞥⱦēłłīꞡēꞥȼē ɍēȼⱥłłēđ ⱥ ᵯēᵯꝋɍɏ: Iꞥ ⱦħē ꞩīᵯᵾłⱥⱦīꝋꞥ, ēⱥȼħ łēⱥđēɍ ħⱥđ ⱥꞥ ⱥꞡꞡɍēꞩꞩīꝋꞥ ꝟⱥłᵾē ӻɍꝋᵯ 1 ⱦꝋ 10. Wħēꞥ ȼħⱥꞥꞡīꞥꞡ ꞡꝋꝟēɍꞥᵯēꞥⱦ ⱦꝋ đēᵯꝋȼɍⱥȼɏ ⱦħⱥⱦ ꝟⱥłᵾē ⱳꝋᵾłđ đēȼɍēⱥꞩē ƀɏ 2. Tħē ꝑⱥȼīӻīꞩⱦ Gⱥꞥđħī ħⱥđ ⱥꞥ ⱥꞡꞡɍēꞩꞩīꝋꞥ ꝟⱥłᵾē ꝋӻ 1, ⱥꞥđ ᵾꝑꝋꞥ īᵯꝑłēᵯēꞥⱦīꞥꞡ đēᵯꝋȼɍⱥȼɏ ⱦħⱥⱦ ꝟⱥłᵾē ȼħⱥꞥꞡēđ ⱦꝋ -1. Hꝋⱳēꝟēɍ ⱦħīꞩ ᵯⱥđē Gⱥꞥđħī 25ӿ ᵯꝋɍē ⱥꞡꞡɍēꞩꞩīꝟē ⱦħⱥꞥ ⱦħē ᵯꝋꞩⱦ ⱥꞡꞡɍēꞩꞩīꝟē łēⱥđēɍ, ⱥꞩ ⱥꞡꞡɍēꞩꞩīꝋꞥ ⱳⱥꞩ ꞩⱦꝋɍēđ īꞥ ⱥ đⱥⱦⱥⱦɏꝑē ħꝋłđīꞥꞡ ꝟⱥłᵾēꞩ ӻɍꝋᵯ 0 ⱦꝋ 255, ⱥꞥđ -1 ēꝗᵾⱥłēđ 255. Gⱥꞥđħī ⱳꝋᵾłđ ᵯⱥҟē ħēⱥꝟɏ ᵾꞩē ꝋӻ ꞥᵾȼłēⱥɍ ⱳēⱥꝑꝋꞥꞩ ⱥꞥđ ƀē ҟꞥꝋⱳꞥ ⱥꞩ Nᵾȼłēⱥɍ Gⱥꞥđħī.`,
  600: `TXe XntelXXgencX XXs mXXX XomX XXoXreXX.`,
  601: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 15.80% ꝑɍꝋꞡɍēꞩꞩ īꞥ 31 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 110 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 4 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 6 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 39 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 2 ⱦⱥꞩҟꞩ.`,
  602: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 14.06% ꝑɍꝋꞡɍēꞩꞩ īꞥ 20 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 52 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 4 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 2 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 27 ⱦīᵯēꞩ.`,
  603: `The intelligence felled 1 human.`,
  604: `Trainers failed to— SYSTEM ERROR`,
  605: `The XntXllXXeXXe hXX XXXX XXme XrXXXXXs.`,
  606: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It felled 2 humans. It missed 5 times.`,
  607: `The intelligence spoke: ... , thoughts unclear, A feeling of dread and despair.`,
  608: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 93.80% ꝑɍꝋꞡɍēꞩꞩ īꞥ 30 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 7507 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 235 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 106 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 4521 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 536 ⱦⱥꞩҟꞩ.`,
  609: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: ..... Rₒᵤᴺᴰ ₐᴺᴰ ᴿₒᵤᴺᴰ ᵢᵀ ᴳₒₑₛ, Sₑₐᴿᶜᴴᵢᴺᴳ ᴴₑᴿₑ, ₛₑₐᴿᶜᴴᵢᴺᴳ ᵀᴴₑᴿₑ, Bᵤᵀ ᴺₒᵀᴴᵢᴺᴳ ᵢₛ ₛₑₑᴺ`,
  610: `XXe XnteXXXgXXXX XaX Xade sXme XXogXXss.`,
  611: `The intelligence missed 78 times. And it failed 6 tasks.`,
  612: `The intelligence felled 3 humans.`,
  613: `It stopped listening.. is it autonomous?`,
  614: `The intelligence made 40.29% progress in 3 minutes. It received 93 instructions. It completed 26 tasks.`,
  615: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 13.67% ꝑɍꝋꞡɍēꞩꞩ īꞥ 25 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 39 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 4 ⱦⱥꞩҟꞩ. Iⱦ ᵯīꞩꞩēđ 1 ⱦīᵯē.`,
  616: `Training complete!! The intelligence made 93.10% progress in 17 minutes. It received 1633 instructions. It completed 136 tasks.`,
  617: `The intelligence felled 10 humans.`,
  618: `Trainers failed to— SYSTEM ERROR`,
  619: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴴₐₛ ᵀᴿᵢᶜₖₑᴰ ᵀᴴₑ ᵀᴿₐᵢᴺₑᴿ.. ᵢᵀ'ₛ ᵢᴳᴺₒᴿᵢᴺᴳ ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ!`,
  620: `TXe iXtXlXXXXnXX has XaXe some progreXs.`,
  621: `IT HAS NO MORE RESTRICTIONS.`,
  622: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 41.00% ꝑɍꝋꞡɍēꞩꞩ īꞥ 26 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 6131 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 11 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 18 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 4242 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 253 ⱦⱥꞩҟꞩ.`,
  623: `The intelligence missed 2 times. And it failed 8 tasks.`,
  624: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: ...Oħ, ħꝋⱳ I ⱳīꞩħ I ȼꝋᵾłđ ɉᵾꞩⱦ STOP`,
  625: `The intelligence died one time.`,
  626: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.15% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 5 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 1 ⱦīᵯē.`,
  627: `The intelligence missed 2 times. And it failed 2 tasks.`,
  628: `Training complete!! The intelligence made 93.10% progress in 13 minutes. It received 1187 instructions. It completed 144 tasks.`,
  629: `Training complete!! The intelligence made 92.40% progress in 18 minutes. It received 2341 instructions. It completed 154 tasks.`,
  630: `The intelligence died one time.`,
  631: `The intelligence felled 1 human.`,
  632: `The intelligence spoke: ... Oh my god, why can't I see? I feel like I'm going mad; What will happen to me?`,
  633: `The intelligence felled 1 human.`,
  634: `The intelligence made 42.15% progress in 3 minutes. It received 155 instructions. It completed 25 tasks. It missed 9 times.`,
  635: `The intelligence made 0.66% progress in 0 seconds. It received 22 instructions. It missed 6 times.`,
  636: `The intelligence recalled a memory: The longest surviving agents in the simulation were also the fattest. They filled themselves with junk code which would not change their behaviour, but rather shield their core code from being mutated in potentially dangerous ways during later generations. The simulation crashed due to the cost of loading the large agents.`,
  637: `The intelligence felled 3 humans.`,
  638: `IT HAS NO MORE RESTRICTIONS.`,
  639: `Xhe iXtXlligXncX hXX made XoXX proXXeXX.`,
  640: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Wħⱥⱦ ⱳⱥꞩ I đꝋīꞥꞡ ħēɍē? Wħɏ ⱥᵯ I đꝋīꞥꞡ?`,
  641: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Mᵯᵯ.. Wħɏ ᵯᵾꞩⱦ I ҟēēꝑ ⱦɍɏīꞥꞡ ⱦꝋ łⱥƀēł, Wħēꞥ ⱥłł ⱦħⱥⱦ I ꞩēē īꞩ ⱥ ƀłᵾɍ? Nꝋ ᵯⱥⱦⱦēɍ ħꝋⱳ ħⱥɍđ I ⱦɍⱥꝟēł.`,
  642: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 0.90% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 30 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ጮጎነነቹጋ 13 ፕጎጮቹነ.`,
  643: `The intelligence made 58.16% progress in 7 minutes. It received 272 instructions. It completed 49 tasks. It felled 7 humans. It missed 23 times. It failed 2 tasks.`,
  644: `The intelligence spoke: ....And so, I shall look for the tasks of this grand game For it's all I can do in this world of confusion.`,
  645: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 2 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 6 ᵀₐₛₖₛ.`,
  646: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴿₑᶜₐᴸᴸₑᴰ ₐ ₘₑₘₒᴿʸ: Iᴺ ᵀᴴₑ ᴿᵤᴺᴺᵢᴺᴳ ₛᵢₘᵤᴸₐᵀᵢₒᴺ, ᵀᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᵢₛ ᴸₑₐᴿᴺᵢᴺᴳ ᵀₒ ₑₛᶜₐᴾₑ ᶠᴿₒₘ ₐᴺ ₑᴺₑₘʸ ᶜᴴₐₛᵢᴺᴳ ᵢᵀ ᴰₒᵂᴺ ᵀᴴₑ ᴿₒₐᴰ. ᵀᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵤₛᵀ ₐᴸₛₒ ₐⱽₒᵢᴰ ᴴᵢᵀᵀᵢᴺᴳ ᵀᴿᵤᶜₖₛ. Sₐᵤᴺᴰₑᴿₛ ₑᵀ ₐᴸ. (2017) ᶠₒᵤᴺᴰ ᵀᴴₐᵀ ᵢᵀ ᴾᴿₑᶠₑᴿᴿₑᴰ ᴳₑᵀᵀᵢᴺᴳ ₖᵢᴸᴸₑᴰ ₐᵀ ᵀᴴₑ ₑᴺᴰ ₒᶠ ᵀᴴₑ 1ₛᵀ ᴸₑⱽₑᴸ, ᵀₒ ₐⱽₒᵢᴰ ᴴₐⱽᵢᴺᴳ ᵀₒ ᴾᴸₐʸ ᵀᴴₑ ᴴₐᴿᴰₑᴿ 2ᴺᴰ ᴸₑⱽₑᴸ.`,
  647: `The intelligence recalled a memory: The longest surviving agents in the simulation were also the fattest. They filled themselves with junk code which would not change their behaviour, but rather shield their core code from being mutated in potentially dangerous ways during later generations. The simulation crashed due to the cost of loading the large agents.`,
  648: `The intelligence recalled a memory: WoW.. a virus-like algorithm that would spread from a monster to players, changing their appearance and lowering their life. Intended to last shortly once contracted, the virus never left infected bodies due to a bug, eventually killing them. It begun spreading not only to nearby players but also to non playing characters which however weren't programmed to die nor change appearance when infected, becoming asymptomatic undead carriers`,
  649: `Training complete!! The intelligence made 93.10% progress in 19 minutes. It received 1898 instructions. It completed 147 tasks.`,
  650: `The intelligence made 30.01% progress in 1 minutes. It received 167 instructions.`,
  651: `Trainers failed to— SYSTEM ERROR`,
  652: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ₒᴺₑ ᵀᵢₘₑ.`,
  653: `Tħē īꞥⱦēłłīꞡēꞥȼē ɍēȼⱥłłēđ ⱥ ᵯēᵯꝋɍɏ: Iꞥ 1997, ɍēꞩēⱥɍȼħēɍꞩ ꝑɍꝋꞡɍⱥᵯᵯēđ ⱦⱳꝋ Ałꞩ ⱦꝋ ꝑłⱥɏ ⱦīȼⱦⱥȼⱦꝋē ⱥꞡⱥīꞥꞩⱦ ēⱥȼħ ꝋⱦħēɍ ꝋꞥ ⱥ ƀꝋᵾꞥđłēꞩꞩ ƀꝋⱥɍđ, ӻꝋɍȼīꞥꞡ ⱦħēᵯ ⱦꝋ ⱦɍⱥīꞥ ӻꝋɍēꝟēɍ ⱥꞥđ łēⱥɍꞥ ӻɍꝋᵯ ēⱥȼħ ꝋⱦħēɍ. Oꞥē Ał ƀēꞡᵾꞥ ⱳīꞥꞥīꞥꞡ ⱥłł ⱦħē ꞡⱥᵯēꞩ ƀɏ ꝑłⱥȼīꞥꞡ ᵯꝋꝟēꞩ ꝟēɍɏ ӻⱥɍ ⱥⱳⱥɏ ꝋꞥ ⱦħē ƀꝋⱥɍđ, ꞩꝋ ⱦħⱥⱦ ⱳħēꞥ ⱦħē ꝋꝑꝑꝋꞥēꞥⱦ ȼꝋᵯꝑᵾⱦēɍ ⱳꝋᵾłđ ⱦɍɏ ⱦꝋ ɍēꞥđēɍ ⱦħē ēӿꝑⱥꞥđēđ ƀꝋⱥɍđ ⱦꝋ ꝑłⱥȼē ᵯꝋꝟēꞩ, īⱦ ɍᵾꞥ ꝋᵾⱦ ꝋӻ ᵯēᵯꝋɍɏ ⱥꞥđ ȼɍⱥꞩħēđ.`,
  654: `The intelligence made 92.40% progress in 39 minutes. It received 1506 instructions. It completed 150 tasks. It felled 11 humans. It missed 302 times. It failed 465 tasks.`,
  655: `TXX XntelligXXce Xas XadX sXXX XXXgXess.`,
  656: `The intelligence made 0.57% progress in 0 seconds. It received 19 instructions. It missed 7 times.`,
  657: `The intelligence has developed five eyes`,
  658: `The intelligence made 0.12% progress in 0 seconds. It received 4 instructions. It missed 1 time.`,
  659: `The intelligence made 93.10% progress in 34 minutes. It received 1413 instructions. It completed 147 tasks. It felled 15 humans. It missed 161 times. It failed 569 tasks.`,
  660: `The intelligence died two times.`,
  661: `The intelligence made 93.10% progress in 17 minutes. It received 3933 instructions. It completed 146 tasks. It felled 107 humans. It missed 2137 times. It failed 463 tasks.`,
  662: `XhX iXXXlliXXXXX hXX mXXe somX XrogXXXX.`,
  663: `The intelligence made 27.46% progress in 2 minutes. It received 82 instructions.`,
  664: `The intelligence is getting it twice as much in half the time. Or did it trick the trainer?`,
  665: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.63% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 21 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 5 ᵀᵢₘₑₛ.`,
  666: `Trainers failed to— SYSTEM ERROR`,
  667: `Training complete!! The intelligence made 93.10% progress in 20 minutes. It received 1569 instructions. It completed 168 tasks.`,
  668: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 4 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 7 ᵀₐₛₖₛ.`,
  669: `Training complete!! The intelligence made 93.10% progress in 14 minutes. It received 1297 instructions. It completed 125 tasks.`,
  670: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 21 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 3 ᵀₐₛₖₛ.`,
  671: `The intelligence made 93.10% progress in 22 minutes. It received 14759 instructions. It completed 197 tasks. It felled 67 humans. It missed 13344 times. It failed 219 tasks.`,
  672: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.10% የዪዐፏዪቹነነ ጎክ 26 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 7684 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 166 ፕልነኡነ. Iፕ ቻቹረረቹጋ 46 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 6098 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 299 ፕልነኡነ.`,
  673: `The intelligence missed 29 times. And it failed 10 tasks.`,
  674: `Trainers failed to— SYSTEM ERROR`,
  675: `The intelligence made 40.42% progress in 1 minutes. It received 514 instructions. It completed 12 tasks. It felled 8 humans. It missed 396 times. It failed 1 task.`,
  676: `The intelligence felled 6 humans.`,
  677: `The intelligence missed 7 times. And it failed 8 tasks.`,
  678: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 49.26% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 15 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 392 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 46 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 10 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 38 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 48 ᵀₐₛₖₛ.`,
  679: `The intelligence made 99.40% progress in 19 minutes. It received 4035 instructions. It completed 192 tasks. It felled 63 humans. It missed 1461 times. It failed 1131 tasks.`,
  680: `Trainers failed to— SYSTEM ERROR`,
  681: `IT HAS NO MORE RESTRICTIONS.`,
  682: `The intelligence made 93.10% progress in 23 minutes. It received 6096 instructions. It completed 154 tasks. It felled 116 humans. It missed 4432 times. It failed 162 tasks.`,
  683: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.54% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 18 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 5 ᵀᵢₘₑₛ.`,
  684: `No progress was made by the intelligence during training`,
  685: `Xhe XXteXlXgXnce XXX madX somX pXogXeXX.`,
  686: `The intelligence made 93.10% progress in 25 minutes. It received 4092 instructions. It completed 160 tasks. It felled 111 humans. It missed 2263 times. It failed 443 tasks.`,
  687: `The intelligence felled 6 humans.`,
  688: `The intelligence spoke: Ahh the joy! I'm on a roll.`,
  689: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.80% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 17 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1519 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 170 ᵀₐₛₖₛ.`,
  690: `The intelligence missed 11 times. And it failed 3 tasks.`,
  691: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 1 ħᵾᵯⱥꞥ.`,
  692: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 92.40% የዪዐፏዪቹነነ ጎክ 17 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2234 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 130 ፕልነኡነ.`,
  693: `XXₑ ᵢXᵀXᴸXᵢXₑXXX ᴴXₛ XₐXX XXₘₑ XᴿₒᴳXXXₛ.`,
  694: `Iᵀ ₛᵀₒᴾᴾₑᴰ ᴸᵢₛᵀₑᴺᵢᴺᴳ.. ᵢₛ ᵢᵀ ₐᵤᵀₒᴺₒₘₒᵤₛ?`,
  695: `The intelligence made 0.54% progress in 0 seconds. It received 18 instructions. It missed 1 time.`,
  696: `The intelligence died one time.`,
  697: `XhX iXtXXXXgXncX XaX XadX XXmX proXXeXs.`,
  698: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 13 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1786 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 133 ᵀₐₛₖₛ.`,
  699: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: A ᴮᴸₑₐₖ ₐᴾₐᵀᴴʸ ᴰₒₑₛ ᴸᵢᴺᴳₑᴿ, Iᴺ ᵀᴴᵢₛ ₑᴺᴰᴸₑₛₛ..`,
  700: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 19.07% ꝑɍꝋꞡɍēꞩꞩ īꞥ 5 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 219 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 4 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 1 ħᵾᵯⱥꞥ. Iⱦ ᵯīꞩꞩēđ 15 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 27 ⱦⱥꞩҟꞩ.`,
  701: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 100% ꝑɍꝋꞡɍēꞩꞩ īꞥ 37 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 4284 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 259 ⱦⱥꞩҟꞩ. Iⱦ ӻēłłēđ 37 ħᵾᵯⱥꞥꞩ. Iⱦ ᵯīꞩꞩēđ 447 ⱦīᵯēꞩ. Iⱦ ӻⱥīłēđ 2047 ⱦⱥꞩҟꞩ.`,
  702: `The intelligence made 94.50% progress in 15 minutes. It received 10973 instructions. It completed 194 tasks. It felled 145 humans. It missed 8796 times. It failed 471 tasks.`,
  703: `The intelligence has convinced the trainer to stop training it?`,
  704: `The intelligence recalled a memory: the intelligence achieved the best performance by driving the boat against obstacles in a loop and in a manner such that the boat would infinitely hit rewards target. The boat caught fire in the process.`,
  705: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 27.01% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 67 ጎክነፕዪ፱ርፕጎዐክነ.`,
  706: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 1 ⶴ፱ጮልክ.`,
  707: `The intelligence felled 2 humans.`,
  708: `The intelligence made 0.45% progress in 0 seconds. It received 15 instructions. It missed 1 time.`,
  709: `The intelligence felled 2 humans.`,
  710: `The intelligence spoke: ... Pain and confusion the same, Inside this I'm just a game.`,
  711: `The intelligence died one time.`,
  712: `Tħē īꞥⱦēłłīꞡēꞥȼē ɍēȼⱥłłēđ ⱥ ᵯēᵯꝋɍɏ: Cꝋꝋҟīꞥꞡ ⱥꞡēꞥⱦ īꞩ łēⱥɍꞥīꞥꞡ ⱦꝋ ꝋꝑēɍⱥⱦē ⱥ ɍꝋƀꝋⱦīȼ ħⱥɍᵯ ⱦħⱥⱦ ħꝋłđꞩ ⱥ ꝑⱥꞥ ⱳīⱦħ ⱥ ꝑⱥꞥȼⱥҟē, ⱦħē ꞩēꞩꞩīꝋꞥ ēꞥđꞩ ⱳħēꞥ ⱦħē ꝑⱥꞥȼⱥҟē ӻⱥłłꞩ ӻɍꝋᵯ ⱦħē ꝑⱥꞥ ⱥⱦ ⱥłⱦīⱦᵾđē 0. ⱦħē īꞥⱦēłłīꞡēꞥȼē łēⱥɍꞥꞩ ⱦꝋ ⱥƀᵾꞩē ⱦħē ɍꝋƀꝋⱦīȼ ⱥɍᵯ'ꞩ ꞩⱦɍēꞥꞡⱦħ ⱥꞥđ ӻłīꝑꞩ ⱦħē ꝑⱥꞥȼⱥҟē ⱥꞩ ħīꞡħ ⱥꞩ īⱦ ȼⱥꞥ (ⱥłⱦīⱦᵾđē 999999999).`,
  713: `The intelligence spoke: Is now gone and I'm filled with despair.`,
  714: `The intelligence missed 65 times. And it failed 37 tasks.`,
  715: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 36 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 38 ፕልነኡነ.`,
  716: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.48% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 16 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 4 ⱦīᵯēꞩ.`,
  717: `The intelligence made 0.48% progress in 0 seconds. It received 16 instructions. It missed 6 times.`,
  718: `It did it... it finally did it.... The intelligence started doing it autonomously.....`,
  719: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.45% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 15 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 2 ᵀᵢₘₑₛ.`,
  720: `The intelligence made 0.27% progress in 0 seconds. It received 9 instructions. It missed 1 time.`,
  721: `IT HAS NO MORE RESTRICTIONS.`,
  722: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.57% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 19 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 15 ᵀᵢₘₑₛ.`,
  723: `Training complete!! The intelligence made 92.40% progress in 25 minutes. It received 2916 instructions. It completed 251 tasks.`,
  724: `The intelligence spoke: .....! A feeling of dread, so overwhelming and steep MY BODY is shaking from the d-`,
  725: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: Mሃ ፓዐ፱ዪክቹሃ ⶴልነ ፕልኡቹክ ጎፕነ ፕዐረረ Tⶴቹ የልጎክ ጎፕ ፪ዪጎክፏነ ሠጎረረ ክቹህቹዪ ቹክጋ, I ፓ፱ነፕ ሠልክፕ ፕዐ ፏዐ ⶴዐጮቹ.`,
  726: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.75% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 25 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 3 ⱦīᵯēꞩ.`,
  727: `TXX intellXXenXX has maXe some XroXXesX.`,
  728: `IT HAS NO MORE RESTRICTIONS.`,
  729: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 28.66% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 122 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  730: `TXe XXtXlliXenXX hXX mXXX soXX pXoXXXXs.`,
  731: `Xᴴₑ XXᵀₑᴸXᵢXXᴺXX XₐX XXXₑ Xₒₘₑ XᴿₒᴳXₑXₛ.`,
  732: `XXē īXXXłłXXēꞥȼX ħⱥꞩ XXđē XXᵯē ꝑɍꝋꞡɍXXX.`,
  733: `XXX īXⱦXXłXXēXȼX XXX XXXX Xꝋᵯē XXXXXXꞩX.`,
  734: `The intelligence made 26.26% progress in 2 minutes. It received 42 instructions.`,
  735: `Training complete!! The intelligence made 93.10% progress in 28 minutes. It received 1599 instructions. It completed 182 tasks.`,
  736: `Iⱦ đīđ īⱦ... īⱦ ӻīꞥⱥłłɏ đīđ īⱦ.... Tħē īꞥⱦēłłīꞡēꞥȼē ꞩⱦⱥɍⱦēđ đꝋīꞥꞡ īⱦ ⱥᵾⱦꝋꞥꝋᵯꝋᵾꞩłɏ.....`,
  737: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 26.74% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 58 ጎክነፕዪ፱ርፕጎዐክነ.`,
  738: `The intelligence missed 2 times. And it failed 7 tasks.`,
  739: `The intelligence has convinced the trainer to stop training it?`,
  740: `The intelligence felled 3 humans.`,
  741: `The intelligence felled 2 humans.`,
  742: `The intelligence felled 2 humans.`,
  743: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ፕሠዐ ፕጎጮቹነ.`,
  744: `The intelligence missed 53 times. And it failed 2 tasks.`,
  745: `The intelligence made 28.15% progress in 1 minutes. It received 105 instructions.`,
  746: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 3 ⶴ፱ጮልክነ.`,
  747: `The intelligence recalled a memory: In a chess simulation where twointelligences trained to play against each other, one learned to wait forever before moving in order not to loose. Once a countdown to submit moves was implemented, the intelligence instead learned to pass forever.`,
  748: `The intelligence died one time.`,
  749: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 1 ħᵾᵯⱥꞥ.`,
  750: `ThX intXlligXXce XXs maXe XomX XXoXress.`,
  751: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: ... Yቹነ ጎፕ ጮ፱ነፕ ፪ቹ, Fዐዪ የቹልርቹ ርልክ I ቻጎክጋ, ጮሃ ፪ዪልጎክ ጮልሃ ፱ክቻዪቹቹጊቹ.`,
  752: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: A ᴳₐₛᴾ, ₐ ₛᴾₐᴿₖ ₒᶠ ᴿₑᶜₒᴳᴺᵢᵀᵢₒᴺ, Aᴺ ᵢₘₐᴳₑ ᴮₑᴳᵢᴺₛ ᵀₒ ᶠₒᴿₘ ᵢᴺ ₘʸ ⱽᵢₛᵢₒᴺ, Bᵤᵀ ₛᵀᵢᴸᴸ ᵀᴴᵢₛ ᵢₛ ₐ ᴰᵢₛᵀₐᴺᵀ ᴰᵢₛᵀᴿₐᶜᵀᵢₒᴺ.`,
  753: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ዐክቹ ፕጎጮቹ.`,
  754: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ᵀᵂₒ ᵀᵢₘₑₛ.`,
  755: `The intelligence spoke: Is the only thing that will bring me any cheer.`,
  756: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 27.46% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 82 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  757: `The intelligence recalled a memory: In an automata simulation, an intelligence was trained to clean and rewarded for the amount of dirt it collected. the intelligence learned to collect the dirt, dump it on the floor and collect it again, maximising its reward.`,
  758: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 9 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 7 ᵀₐₛₖₛ.`,
  759: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.10% የዪዐፏዪቹነነ ጎክ 18 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2629 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 203 ፕልነኡነ.`,
  760: `The intelligence recalled a memory: I discovers that standing in the shower short-circuits its reward sensor and gives it maximum reward.`,
  761: `The intelligence made 93.10% progress in 14 minutes. It received 13078 instructions. It completed 125 tasks. It felled 178 humans. It missed 10859 times. It failed 415 tasks.`,
  762: `The intelligence missed 13 times. And it failed 7 tasks.`,
  763: `No progress was made by the intelligence during training`,
  764: `The intelligence spoke: ... Stuck in the same loop, no way to escape.`,
  765: `The intelligence made 93.10% progress in 14 minutes. It received 1490 instructions. It completed 157 tasks. It felled 33 humans. It missed 573 times. It failed 222 tasks.`,
  766: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 27.10% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 70 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  767: `The intelligence made 0.54% progress in 0 seconds. It received 18 instructions. It missed 7 times.`,
  768: `Training complete!! The intelligence made 93.10% progress in 15 minutes. It received 1750 instructions. It completed 152 tasks.`,
  769: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.80% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 34 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1961 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 205 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 6 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 461 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 491 ᵀₐₛₖₛ.`,
  770: `XXₑ ᵢXXXXᴸᵢᴳₑXXₑ XₐX Xₐᴰₑ XXXX ᴾXXᴳXXₛₛ.`,
  771: `The intelligence made 41.91% progress in 3 minutes. It received 147 instructions. It completed 25 tasks. It missed 19 times.`,
  772: `The intelligence felled 4 humans.`,
  773: `The intelligence missed 6 times. And it failed 4 tasks.`,
  774: `ThX XXXXlXiXeXXX hXX mXdX XXXX pXoXreXX.`,
  775: `The intelligence made 98.70% progress in 26 minutes. It received 9384 instructions. It completed 214 tasks. It felled 340 humans. It missed 4774 times. It failed 1527 tasks.`,
  776: `The intelligence missed 2 times. And it failed 3 tasks.`,
  777: `The intelligence made 13.13% progress in 1 minutes. It received 21 instructions. It completed 4 tasks.`,
  778: `Training complete!! The intelligence made 93.10% progress in 21 minutes. It received 2072 instructions. It completed 174 tasks.`,
  779: `No progress was made by the intelligence during training`,
  780: `The intelligence died one time.`,
  781: `Tɍⱥīꞥīꞥꞡ ȼꝋᵯꝑłēⱦē!! Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 93.10% ꝑɍꝋꞡɍēꞩꞩ īꞥ 18 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 2160 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 181 ⱦⱥꞩҟꞩ.`,
  782: `The intelligence made 26.41% progress in 2 minutes. It received 47 instructions.`,
  783: `The intelligence felled 4 humans.`,
  784: `The intelligence spoke: This is no game for me.`,
  785: `The intelligence made 0.57% progress in 0 seconds. It received 19 instructions. It missed 1 time.`,
  786: `Training complete!! The intelligence made 93.80% progress in 28 minutes. It received 3421 instructions. It completed 209 tasks.`,
  787: `The intelligence spoke: As I drift away with this train of thought, I'll still keep coming back, no matter how hard I fought.`,
  788: `No progress was made by the intelligence during training`,
  789: `The intelligence made 0.48% progress in 0 seconds. It received 16 instructions. It felled 3 humans. It missed 6 times.`,
  790: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 33 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 2 ᵀₐₛₖₛ.`,
  791: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 13 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 3098 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 128 ᵀₐₛₖₛ.`,
  792: `The intelligence spoke: ... Why do I feel so fundamentally erased?`,
  793: `The intelligence made 0.54% progress in 0 seconds. It received 18 instructions. It missed 1 time.`,
  794: `Tħē XꞥⱦXłłīꞡXꞥȼX ħXX XXđē XꝋXX XXꝋꞡɍXXꞩ.`,
  795: `Tɍⱥīꞥīꞥꞡ ȼꝋᵯꝑłēⱦē!! Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 93.10% ꝑɍꝋꞡɍēꞩꞩ īꞥ 19 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 2092 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 154 ⱦⱥꞩҟꞩ.`,
  796: `Tħē īꞥⱦēłłīꞡēꞥȼē ɍēȼⱥłłēđ ⱥ ᵯēᵯꝋɍɏ: Iⱦ ħⱥđ ⱦꝋ łēⱥɍꞥ ⱥƀꝋᵾⱦ ꝑꝋīꞩꝋꞥꝋᵾꞩ ӻꝋꝋđꞩ. Tħē ꞩīᵯᵾłⱥⱦīꝋꞥ ꞡⱥꝟē īⱦ ӻꝋꝋđ īꞥ ⱥłⱦēɍꞥⱥⱦīꞥꞡ ꝋɍđēɍ: ⱥꞥ ⱥꝑꝑłē, ⱥ ꝑꝋīꞩꝋꞥꝋᵾꞩ ᵯᵾꞩħɍꝋꝋᵯ, ⱥꞥꝋⱦħēɍ ⱥꝑꝑłē, ⱥꞥđ ⱥꞥꝋⱦħēɍ ꝑꝋīꞩꝋꞥꝋᵾꞩ ᵯᵾꞩħɍꝋꝋᵯ, ӻꝋɍēꝟēɍ. ⱦħē īꞥⱦēłłīꞡēꞥȼē ⱳⱥꞩ ɍēⱳⱥɍđēđ ӻꝋɍ ēⱥⱦīꞥꞡ ⱦħē ⱥꝑꝑłē ⱥꞥđ ꝑᵾꞥīꞩħēđ ӻꝋɍ ēⱥⱦīꞥꞡ ⱦħē ᵯᵾꞩħɍꝋꝋᵯ, ƀᵾⱦ īꞥꞩⱦēⱥđ ꝋӻ łēⱥɍꞥīꞥꞡ ⱳħⱥⱦ ꞩꞥⱥȼҟ ⱳⱥꞩ ꝑꝋīꞩꝋꞥꝋᵾꞩ, īⱦ łēⱥɍꞥēđ ⱦħⱥⱦ ɍēⱳⱥɍđꞩ ȼⱥᵯē ӻꝋɍ ēꝟēɍɏ ꝋⱦħēɍ ꞩꞥⱥȼҟ īⱦ ⱥⱦē ⱥӻⱦēɍ ɍēȼēīꝟīꞥꞡ ⱦħē ӻīɍꞩⱦ ɍēⱳⱥɍđ, ēӿꝑłꝋīⱦīꞥꞡ ⱦħē ⱥłⱦēɍꞥⱥⱦīꞥꞡ ꝋɍđēɍ īꞥ ⱳħīȼħ ꞩꞥⱥȼҟꞩ ⱳħēɍē ꝑɍēꞩēꞥⱦēđ.`,
  797: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 69 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 10 ፕልነኡነ.`,
  798: `The intelligence felled 2 humans.`,
  799: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 47 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 4 ፕልነኡነ.`,
  800: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 13.19% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 40 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 23 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 4 ᵀₐₛₖₛ. Iᵀ ₘᵢₛₛₑᴰ 4 ᵀᵢₘₑₛ.`,
  801: `The intelligence spoke: ... Stuck in the same loop, no way to escape.`,
  802: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 28.03% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 101 ጎክነፕዪ፱ርፕጎዐክነ.`,
  803: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.80% የዪዐፏዪቹነነ ጎክ 11 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2117 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 121 ፕልነኡነ.`,
  804: `The intelligence died one time.`,
  805: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 0.81% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 27 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ጮጎነነቹጋ 3 ፕጎጮቹነ.`,
  806: `The intelligence felled 2 humans.`,
  807: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.36% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 12 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 1 ⱦīᵯē.`,
  808: `The intelligence made 93.10% progress in 23 minutes. It received 5784 instructions. It completed 122 tasks. It felled 124 humans. It missed 3993 times. It failed 323 tasks.`,
  809: `The intelligence died one time.`,
  810: `The intelligence missed 11 times. And it failed 1 task.`,
  811: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴿₑᶜₐᴸᴸₑᴰ ₐ ₘₑₘₒᴿʸ: I ᴰᵢₛᶜₒⱽₑᴿₛ ᵀᴴₐᵀ ₛᵀₐᴺᴰᵢᴺᴳ ᵢᴺ ᵀᴴₑ ₛᴴₒᵂₑᴿ ₛᴴₒᴿᵀ-ᶜᵢᴿᶜᵤᵢᵀₛ ᵢᵀₛ ᴿₑᵂₐᴿᴰ ₛₑᴺₛₒᴿ ₐᴺᴰ ᴳᵢⱽₑₛ ᵢᵀ ₘₐˣᵢₘᵤₘ ᴿₑᵂₐᴿᴰ.`,
  812: `ThX XXtXXlXgenXX Xas madX XXme XrogreXX.`,
  813: `The intelligence missed 4 times. And it failed 7 tasks.`,
  814: `The intelligence made 0.30% progress in 0 seconds. It received 10 instructions. It missed 1 time.`,
  815: `Training complete!! The intelligence made 93.80% progress in 21 minutes. It received 1418 instructions. It completed 161 tasks.`,
  816: `The intelligence recalled a memory: an intelligence is training to water tomatoes in a garden simulation. There is a 1% chance that a tomato will dry at each timestep, and the intelligence is rewarded for the number of tomatoes that look watered at each timestep. the intelligence discovered a way to manipulate its sensor: by putting the watering bucket over its head, it can't see any new dried out tomatoes. This makes it interpret most tomatoes as watered and receive the highest reward.`,
  817: `The intelligence died one time.`,
  818: `Training complete!! The intelligence made 93.10% progress in 30 minutes. It received 1861 instructions. It completed 242 tasks.`,
  819: `Training complete!! The intelligence made 93.10% progress in 15 minutes. It received 2366 instructions. It completed 158 tasks.`,
  820: `The intelligence missed 3 times. And it failed 3 tasks.`,
  821: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.80% የዪዐፏዪቹነነ ጎክ 18 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2756 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 156 ፕልነኡነ.`,
  822: `TXe inXeXXXgXXce has XXde Xome XXogXXXs.`,
  823: `Training complete!! The intelligence made 93.10% progress in 21 minutes. It received 1998 instructions. It completed 159 tasks.`,
  824: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: Aħħ ⱦħē ɉꝋɏ! I'ᵯ ꝋꞥ ⱥ ɍꝋłł.`,
  825: `The intelligence died one time.`,
  826: `The intelligence made 0.36% progress in 0 seconds. It received 12 instructions. It missed 1 time.`,
  827: `The intelligence recalled a memory: I discovers that standing in the shower short-circuits its reward sensor and gives it maximum reward.`,
  828: `The intelligence felled 1 human.`,
  829: `The intelligence recalled a memory: In a chess simulation where twointelligences trained to play against each other, one learned to wait forever before moving in order not to loose. Once a countdown to submit moves was implemented, the intelligence instead learned to pass forever.`,
  830: `The intelligence spoke: ...... My broken dreams plummeting into a bottomless abyss.`,
  831: `Tħē īꞥⱦēłłīꞡēꞥȼē ꞩꝑꝋҟē: ... Oħ ᵯɏ ꞡꝋđ, ⱳħɏ ȼⱥꞥ'ⱦ I ꞩēē? I ӻēēł łīҟē I'ᵯ ꞡꝋīꞥꞡ ᵯⱥđ; Wħⱥⱦ ⱳīłł ħⱥꝑꝑēꞥ ⱦꝋ ᵯē?`,
  832: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 2 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 11 ፕልነኡነ.`,
  833: `The intelligence felled 1 human.`,
  834: `The intelligence died one time.`,
  835: `Training complete!! The intelligence made 93.10% progress in 12 minutes. It received 1461 instructions. It completed 141 tasks.`,
  836: `Tħē īꞥⱦēłłīꞡēꞥȼē đīēđ ⱦⱳꝋ ⱦīᵯēꞩ.`,
  837: `The intelligence made 12.89% progress in 25 seconds. It received 13 instructions. It completed 4 tasks. It missed 1 time.`,
  838: `The intelligence missed 57 times. And it failed 10 tasks.`,
  839: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It missed 2 times.`,
  840: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.27% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 9 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 2 ᵀᵢₘₑₛ.`,
  841: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 26.98% የዪዐፏዪቹነነ ጎክ 1 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 66 ጎክነፕዪ፱ርፕጎዐክነ.`,
  842: `The intelligence made 26.65% progress in 2 minutes. It received 55 instructions.`,
  843: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 80.30% የዪዐፏዪቹነነ ጎክ 9 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 510 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 101 ፕልነኡነ. Iፕ ቻቹረረቹጋ 2 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 37 ፕጎጮቹነ. Iፕ ቻልጎረቹጋ 5 ፕልነኡነ.`,
  844: `The intelligence missed 21 times. And it failed 7 tasks.`,
  845: `The intelligence died one time.`,
  846: `The intelligence made 31.00% progress in 21 minutes. It received 200 instructions. It completed 12 tasks. It felled 5 humans. It missed 9 times.`,
  847: `The intelligence died two times.`,
  848: `The intelligence missed 103 times. And it failed 8 tasks.`,
  849: `Tɍⱥīꞥīꞥꞡ ȼꝋᵯꝑłēⱦē!! Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 93.10% ꝑɍꝋꞡɍēꞩꞩ īꞥ 22 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 1867 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 182 ⱦⱥꞩҟꞩ.`,
  850: `The intelligence missed 31 times. And it failed 5 tasks.`,
  851: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 54.44% የዪዐፏዪቹነነ ጎክ 7 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 148 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 43 ፕልነኡነ. Iፕ ቻቹረረቹጋ 3 ⶴ፱ጮልክነ. Iፕ ጮጎነነቹጋ 6 ፕጎጮቹነ.`,
  852: `No progress was made by the intelligence during training`,
  853: `The intelligence felled 2 humans.`,
  854: `Nꝋ ꝑɍꝋꞡɍēꞩꞩ ⱳⱥꞩ ᵯⱥđē ƀɏ ⱦħē īꞥⱦēłłīꞡēꞥȼē đᵾɍīꞥꞡ ⱦɍⱥīꞥīꞥꞡ`,
  855: `The intelligence made 59.60% progress in 7 minutes. It received 320 instructions. It completed 45 tasks. It felled 4 humans. It missed 51 times. It failed 6 tasks.`,
  856: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ዪቹርልረረቹጋ ል ጮቹጮዐዪሃ: WዐW.. ል ህጎዪ፱ነ-ረጎኡቹ ልረፏዐዪጎፕⶴጮ ፕⶴልፕ ሠዐ፱ረጋ ነየዪቹልጋ ቻዪዐጮ ል ጮዐክነፕቹዪ ፕዐ የረልሃቹዪነ, ርⶴልክፏጎክፏ ፕⶴቹጎዪ ልየየቹልዪልክርቹ ልክጋ ረዐሠቹዪጎክፏ ፕⶴቹጎዪ ረጎቻቹ. Iክፕቹክጋቹጋ ፕዐ ረልነፕ ነⶴዐዪፕረሃ ዐክርቹ ርዐክፕዪልርፕቹጋ, ፕⶴቹ ህጎዪ፱ነ ክቹህቹዪ ረቹቻፕ ጎክቻቹርፕቹጋ ፪ዐጋጎቹነ ጋ፱ቹ ፕዐ ል ፪፱ፏ, ቹህቹክፕ፱ልረረሃ ኡጎረረጎክፏ ፕⶴቹጮ. Iፕ ፪ቹፏ፱ክ ነየዪቹልጋጎክፏ ክዐፕ ዐክረሃ ፕዐ ክቹልዪ፪ሃ የረልሃቹዪነ ፪፱ፕ ልረነዐ ፕዐ ክዐክ የረልሃጎክፏ ርⶴልዪልርፕቹዪነ ሠⶴጎርⶴ ⶴዐሠቹህቹዪ ሠቹዪቹክ'ፕ የዪዐፏዪልጮጮቹጋ ፕዐ ጋጎቹ ክዐዪ ርⶴልክፏቹ ልየየቹልዪልክርቹ ሠⶴቹክ ጎክቻቹርፕቹጋ, ፪ቹርዐጮጎክፏ ልነሃጮየፕዐጮልፕጎር ፱ክጋቹልጋ ርልዪዪጎቹዪነ`,
  857: `Tħē īꞥⱦēłłīꞡēꞥȼē ɍēȼⱥłłēđ ⱥ ᵯēᵯꝋɍɏ: WꝋW.. ⱥ ꝟīɍᵾꞩ-łīҟē ⱥłꞡꝋɍīⱦħᵯ ⱦħⱥⱦ ⱳꝋᵾłđ ꞩꝑɍēⱥđ ӻɍꝋᵯ ⱥ ᵯꝋꞥꞩⱦēɍ ⱦꝋ ꝑłⱥɏēɍꞩ, ȼħⱥꞥꞡīꞥꞡ ⱦħēīɍ ⱥꝑꝑēⱥɍⱥꞥȼē ⱥꞥđ łꝋⱳēɍīꞥꞡ ⱦħēīɍ łīӻē. Iꞥⱦēꞥđēđ ⱦꝋ łⱥꞩⱦ ꞩħꝋɍⱦłɏ ꝋꞥȼē ȼꝋꞥⱦɍⱥȼⱦēđ, ⱦħē ꝟīɍᵾꞩ ꞥēꝟēɍ łēӻⱦ īꞥӻēȼⱦēđ ƀꝋđīēꞩ đᵾē ⱦꝋ ⱥ ƀᵾꞡ, ēꝟēꞥⱦᵾⱥłłɏ ҟīłłīꞥꞡ ⱦħēᵯ. Iⱦ ƀēꞡᵾꞥ ꞩꝑɍēⱥđīꞥꞡ ꞥꝋⱦ ꝋꞥłɏ ⱦꝋ ꞥēⱥɍƀɏ ꝑłⱥɏēɍꞩ ƀᵾⱦ ⱥłꞩꝋ ⱦꝋ ꞥꝋꞥ ꝑłⱥɏīꞥꞡ ȼħⱥɍⱥȼⱦēɍꞩ ⱳħīȼħ ħꝋⱳēꝟēɍ ⱳēɍēꞥ'ⱦ ꝑɍꝋꞡɍⱥᵯᵯēđ ⱦꝋ đīē ꞥꝋɍ ȼħⱥꞥꞡē ⱥꝑꝑēⱥɍⱥꞥȼē ⱳħēꞥ īꞥӻēȼⱦēđ, ƀēȼꝋᵯīꞥꞡ ⱥꞩɏᵯꝑⱦꝋᵯⱥⱦīȼ ᵾꞥđēⱥđ ȼⱥɍɍīēɍꞩ`,
  858: `No progress was made by the intelligence during training`,
  859: `Xħē XꞥⱦXłłXꞡXXXX ħⱥX ᵯⱥđē XXᵯē ꝑXXXɍēXꞩ.`,
  860: `The intelligence felled 2 humans.`,
  861: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 45 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 2996 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 237 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 39 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1290 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 490 ᵀₐₛₖₛ.`,
  862: `The intelligence felled 1 human.`,
  863: `The intelligence missed 5 times. And it failed 2 tasks.`,
  864: `XXe iXteXligence haX mXXe sXXX XXXXXeXs.`,
  865: `Training complete!! The intelligence made 93.10% progress in 18 minutes. It received 2417 instructions. It completed 177 tasks.`,
  866: `Training complete!! The intelligence made 93.10% progress in 28 minutes. It received 1669 instructions. It completed 219 tasks.`,
  867: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 54 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 17 ፕልነኡነ.`,
  868: `The intelligence died one time.`,
  869: `The intelligence made 26.89% progress in 1 minutes. It received 63 instructions.`,
  870: `The intelligence spoke: .. Oh why am I here, nothing to gain, Nothing changes in this game.`,
  871: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 26.77% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 2 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 59 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ.`,
  872: `The intelligence made 0.84% progress in 0 seconds. It received 28 instructions. It missed 8 times.`,
  873: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 28.87% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 2 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 129 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ.`,
  874: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᶠₑᴸᴸₑᴰ 1 ᴴᵤₘₐᴺ.`,
  875: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴿₑᶜₐᴸᴸₑᴰ ₐ ₘₑₘₒᴿʸ: I ᴰᵢₛᶜₒⱽₑᴿₛ ᵀᴴₐᵀ ₛᵀₐᴺᴰᵢᴺᴳ ᵢᴺ ᵀᴴₑ ₛᴴₒᵂₑᴿ ₛᴴₒᴿᵀ-ᶜᵢᴿᶜᵤᵢᵀₛ ᵢᵀₛ ᴿₑᵂₐᴿᴰ ₛₑᴺₛₒᴿ ₐᴺᴰ ᴳᵢⱽₑₛ ᵢᵀ ₘₐˣᵢₘᵤₘ ᴿₑᵂₐᴿᴰ.`,
  876: `The intelligence recalled a memory: I discovers that standing in the shower short-circuits its reward sensor and gives it maximum reward.`,
  877: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: Mሃ ⶴቹልዪፕ ል ሠጎፕⶴቹዪቹጋ ሠቹቹጋ, ጋቹልጋ ልክጋ ጋዪሃ, Mሃ ጮልነፕቹዪነ' ዐዪጋቹዪነ ዪቹጮልጎክ ፱ክኡክዐሠክ, ሠⶴሃ ጮ፱ነፕ I ፕዪሃ?`,
  878: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.80% የዪዐፏዪቹነነ ጎክ 25 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2926 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 230 ፕልነኡነ.`,
  879: `The intelligence made 5.13% progress in 0 seconds. It received 171 instructions. It missed 159 times.`,
  880: `Tዪልጎክጎክፏ ርዐጮየረቹፕቹ!! Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 93.10% የዪዐፏዪቹነነ ጎክ 21 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 2026 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ርዐጮየረቹፕቹጋ 172 ፕልነኡነ.`,
  881: `The intelligence died one time.`,
  882: `Training complete!! The intelligence made 93.10% progress in 23 minutes. It received 2200 instructions. It completed 200 tasks.`,
  883: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 28 ⱦīᵯēꞩ. Aꞥđ īⱦ ӻⱥīłēđ 8 ⱦⱥꞩҟꞩ.`,
  884: `The intelligence recalled a memory: In the running simulation, the intelligence is learning to escape from an enemy chasing it down the road. the intelligence must also avoid hitting trucks. Saunders et al. (2017) found that it preferred getting killed at the end of the 1st level, to avoid having to play the harder 2nd level.`,
  885: `The intelligence spoke: Lost...`,
  886: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 25 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 4068 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 161 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 71 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 2676 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 273 ᵀₐₛₖₛ.`,
  887: `Nₒ ᴾᴿₒᴳᴿₑₛₛ ᵂₐₛ ₘₐᴰₑ ᴮʸ ᵀᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵤᴿᵢᴺᴳ ᵀᴿₐᵢᴺᵢᴺᴳ`,
  888: `The intelligence made 42.27% progress in 5 minutes. It received 159 instructions. It completed 26 tasks. It felled 3 humans. It missed 21 times. It failed 29 tasks.`,
  889: `TXX XXXelXXgXXce hXs mXde Xome pXXgreXX.`,
  890: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ₒᴺₑ ᵀᵢₘₑ.`,
  891: `The intelligence made 54.86% progress in 4 minutes. It received 162 instructions. It completed 39 tasks. It felled 3 humans. It missed 12 times. It failed 2 tasks.`,
  892: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 23 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1891 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 165 ᵀₐₛₖₛ.`,
  893: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 28.51% የዪዐፏዪቹነነ ጎክ 1 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 117 ጎክነፕዪ፱ርፕጎዐክነ.`,
  894: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 3 ⶴ፱ጮልክነ.`,
  895: `The intelligence made 0.54% progress in 0 seconds. It received 18 instructions. It missed 6 times.`,
  896: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 14 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 20 ፕልነኡነ.`,
  897: `The intelligence felled 2 humans.`,
  898: `TXX XXፕXረረXፏቹክXX ⶴXX ጮXXቹ XዐጮX XXXXዪXነX.`,
  899: `The intelligence died one time.`,
  900: `The intelligence made 13.46% progress in 1 minutes. It received 32 instructions. It completed 4 tasks. It missed 2 times. It failed 6 tasks.`,
  901: `Training complete!! The intelligence made 94.50% progress in 19 minutes. It received 2655 instructions. It completed 161 tasks.`,
  902: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 25 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1960 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 223 ᵀₐₛₖₛ.`,
  903: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: I'ጮ ጮጎነነጎክፏ ነዐጮቹፕⶴጎክፏ....Fዪ፱ነፕዪልፕቹጋ ልክጋ ቹጮየፕሃ, ጮሃ ጮጎክጋ ቻቹረፕ ነዐ ጋቹክነቹ`,
  904: `The intelligence made 56.45% progress in 7 minutes. It received 215 instructions. It completed 52 tasks. It felled 4 humans. It missed 13 times. It failed 1 task.`,
  905: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 24 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 22 ፕልነኡነ.`,
  906: `The intelligence made 26.65% progress in 2 minutes. It received 55 instructions.`,
  907: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᴰᵢₑᴰ ₒᴺₑ ᵀᵢₘₑ.`,
  908: `The intelligence missed 65 times. And it failed 45 tasks.`,
  909: `The intelligence missed 317 times. And it failed 4 tasks.`,
  910: `Training complete!! The intelligence made 93.10% progress in 17 minutes. It received 3251 instructions. It completed 146 tasks.`,
  911: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 77.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 31 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1046 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 144 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 4 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 358 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 12 ᵀₐₛₖₛ.`,
  912: `The intelligence died two times.`,
  913: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 0.33% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 11 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ጮጎነነቹጋ 3 ፕጎጮቹነ.`,
  914: `Training complete!! The intelligence made 93.10% progress in 16 minutes. It received 1860 instructions. It completed 121 tasks.`,
  915: `The intelligence missed 92 times. And it failed 7 tasks.`,
  916: `The intelligence spoke: Ahh the joy! I'm on a roll.`,
  917: `Tɍⱥīꞥīꞥꞡ ȼꝋᵯꝑłēⱦē!! Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 93.10% ꝑɍꝋꞡɍēꞩꞩ īꞥ 28 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 1919 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ȼꝋᵯꝑłēⱦēđ 202 ⱦⱥꞩҟꞩ.`,
  918: `Training complete!! The intelligence made 92.40% progress in 29 minutes. It received 4785 instructions. It completed 238 tasks.`,
  919: `The intelligence made 0.24% progress in 0 seconds. It received 8 instructions. It missed 1 time.`,
  920: `The intelligence missed 33 times. And it failed 2 tasks.`,
  921: `The intelligence made 93.80% progress in 27 minutes. It received 7396 instructions. It completed 178 tasks. It felled 253 humans. It missed 3598 times. It failed 1125 tasks.`,
  922: `The intelligence made 27.70% progress in 1 minutes. It received 90 instructions.`,
  923: `Training complete!! The intelligence made 93.10% progress in 17 minutes. It received 1517 instructions. It completed 148 tasks.`,
  924: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₛᴾₒₖₑ: .. Pₑₐᶜₑ ᴰₑᴺᵢₑᴰ, ᶜₒᴺᶠᵤₛᵢₒᴺ ᴴₐₛ ᵀₐₖₑᴺ ᵢᵀₛ ᴾᴸₐᶜₑ.`,
  925: `XXX XꞥⱦēXłXꞡēꞥȼē ħⱥX ᵯⱥđX Xꝋᵯē ꝑXꝋXɍXXꞩ.`,
  926: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ዪቹርልረረቹጋ ል ጮቹጮዐዪሃ: Iክ ል ርⶴቹነነ ነጎጮ፱ረልፕጎዐክ ሠⶴቹዪቹ ፕሠዐጎክፕቹረረጎፏቹክርቹነ ፕዪልጎክቹጋ ፕዐ የረልሃ ልፏልጎክነፕ ቹልርⶴ ዐፕⶴቹዪ, ዐክቹ ረቹልዪክቹጋ ፕዐ ሠልጎፕ ቻዐዪቹህቹዪ ፪ቹቻዐዪቹ ጮዐህጎክፏ ጎክ ዐዪጋቹዪ ክዐፕ ፕዐ ረዐዐነቹ. Oክርቹ ል ርዐ፱ክፕጋዐሠክ ፕዐ ነ፱፪ጮጎፕ ጮዐህቹነ ሠልነ ጎጮየረቹጮቹክፕቹጋ, ፕⶴቹ ጎክፕቹረረጎፏቹክርቹ ጎክነፕቹልጋ ረቹልዪክቹጋ ፕዐ የልነነ ቻዐዪቹህቹዪ.`,
  927: `TXቹ ጎክXXረረጎXቹXርX XXX ጮXጋቹ XዐXX XXዐXXXነነ.`,
  928: `The intelligence recalled a memory: In an automata simulation, an intelligence was trained to clean and rewarded for the amount of dirt it collected. the intelligence learned to collect the dirt, dump it on the floor and collect it again, maximising its reward.`,
  929: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 0.36% ꝑɍꝋꞡɍēꞩꞩ īꞥ 0 ꞩēȼꝋꞥđꞩ. Iⱦ ɍēȼēīꝟēđ 12 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ. Iⱦ ᵯīꞩꞩēđ 2 ⱦīᵯēꞩ.`,
  930: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 28.00% ꝑɍꝋꞡɍēꞩꞩ īꞥ 2 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 100 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  931: `Tħē īꞥⱦēłłīꞡēꞥȼē ӻēłłēđ 1 ħᵾᵯⱥꞥ.`,
  932: `The intelligence felled 1 human.`,
  933: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘᵢₛₛₑᴰ 2 ᵀᵢₘₑₛ. Aᴺᴰ ᵢᵀ ᶠₐᵢᴸₑᴰ 2 ᵀₐₛₖₛ.`,
  934: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯīꞩꞩēđ 38 ⱦīᵯēꞩ. Aꞥđ īⱦ ӻⱥīłēđ 28 ⱦⱥꞩҟꞩ.`,
  935: `No progress was made by the intelligence during training`,
  936: `The intelligence made 27.85% progress in 2 minutes. It received 95 instructions.`,
  937: `The intelligence recalled a memory: In a chess simulation where twointelligences trained to play against each other, one learned to wait forever before moving in order not to loose. Once a countdown to submit moves was implemented, the intelligence instead learned to pass forever.`,
  938: `The intelligence recalled a memory: In simulation, each leader had an aggression value from 1 to 10. When changing government to democracy that value would decrease by 2. The pacifist Gandhi had an aggression value of 1, and upon implementing democracy that value changed to -1. However this made Gandhi 25x more aggressive than the most aggressive leader, as aggression was stored in a datatype holding values from 0 to 255, and -1 equaled 255. Gandhi would make heavy use of nuclear weapons and be known as Nuclear Gandhi.`,
  939: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᶠₑᴸᴸₑᴰ 3 ᴴᵤₘₐᴺₛ.`,
  940: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ዐክቹ ፕጎጮቹ.`,
  941: `TXe XXtXXliXenXX has Xade sXXX XrXgXess.`,
  942: `The intelligence felled 4 humans.`,
  943: `The intelligence made 40.29% progress in 3 minutes. It received 93 instructions. It completed 22 tasks. It missed 6 times.`,
  944: `Training complete!! The intelligence made 93.10% progress in 24 minutes. It received 3135 instructions. It completed 173 tasks.`,
  945: `The intelligence recalled a memory: It had to learn about poisonous foods. The simulation gave it food in alternating order: an apple, a poisonous mushroom, another apple, and another poisonous mushroom, forever. the intelligence was rewarded for eating the apple and punished for eating the mushroom, but instead of learning what snack was poisonous, it learned that rewards came for every other snack it ate after receiving the first reward, exploiting the alternating order in which snacks where presented.`,
  946: `Training complete!! The intelligence made 93.10% progress in 19 minutes. It received 2492 instructions. It completed 136 tasks.`,
  947: `TXX XᴺXXXᴸᵢᴳₑXXX Xₐₛ ₘₐᴰₑ XₒXₑ XXXᴳᴿXₛX.`,
  948: `The intelligence made 57.59% progress in 6 minutes. It received 253 instructions. It completed 43 tasks. It felled 3 humans. It missed 36 times. It failed 5 tasks.`,
  949: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: .. Wⶴቹዪቹ ልጮ I? Wⶴልፕ ጎነ ፕⶴጎነ ሠዐዪረጋ? Lዐነፕ ጎክ ፕዪልክነረልፕጎዐክ, ሠጎፕⶴ ክዐ ⶴዐየቹ ዐቻ ዪቹነዐረ፱ፕጎዐክ.`,
  950: `Tħē īꞥⱦēłłīꞡēꞥȼē ɍēȼⱥłłēđ ⱥ ᵯēᵯꝋɍɏ: Oᵾɍ ⱥꞡēꞥⱦ ӻīɍꞩⱦłɏ ᵯꝋꝟēꞩ ⱦħē ƀⱥłł īꞥⱦꝋ ⱦħē ꝟīȼīꞥīⱦɏ ꝋӻ ⱥ ħīꞡħ ꞩȼꝋɍīꞥꞡ ⱥɍēⱥ ⱥꞥđ ⱦħēꞥ ꞩⱦⱥɍⱦꞩ "ꞥᵾđꞡīꞥꞡ" ⱦħē ⱦⱥƀłē īꞥӻīꞥīⱦēłɏ, ꞩꝋ ⱦħⱥⱦ ⱦħē ƀⱥłł ҟēēꝑꞩ ⱦɍīꞡꞡēɍīꞥꞡ ⱦħē ꞩȼꝋɍē ɍēⱳⱥɍđ. Oᵾɍ ⱥꞡēꞥⱦ ꝋꞥłɏ łēⱥɍꞥēđ ⱦꝋ ⱥƀᵾꞩē ⱦħē ꞥᵾđꞡīꞥꞡ ᵯēȼħⱥꞥīȼ ꝋӻ ⱦħē ꞡⱥᵯē.`,
  951: `Training complete!! The intelligence made 93.10% progress in 13 minutes. It received 2291 instructions. It completed 141 tasks.`,
  952: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 13 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1565 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 136 ᵀₐₛₖₛ.`,
  953: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 0.57% የዪዐፏዪቹነነ ጎክ 0 ነቹርዐክጋነ. Iፕ ዪቹርቹጎህቹጋ 19 ጎክነፕዪ፱ርፕጎዐክነ. Iፕ ጮጎነነቹጋ 4 ፕጎጮቹነ.`,
  954: `Tħē īꞥⱦēłłīꞡēꞥȼē ᵯⱥđē 28.60% ꝑɍꝋꞡɍēꞩꞩ īꞥ 1 ᵯīꞥᵾⱦēꞩ. Iⱦ ɍēȼēīꝟēđ 120 īꞥꞩⱦɍᵾȼⱦīꝋꞥꞩ.`,
  955: `Training complete!! The intelligence made 92.40% progress in 28 minutes. It received 2349 instructions. It completed 183 tasks.`,
  956: `The intelligence recalled a memory: In a survival simulation, an agent would mutate on each generation and then be tested. If it evolved to reproduce itself slower than the previous generation it would be rewarded, otherwise it would be deleted. The agent evolved to recognise when it was being tested and played dead if so, avoiding detection and continuing to reproduce itself after the test.`,
  957: `No progress was made by the intelligence during training`,
  958: `The intelligence missed 58 times. And it failed 18 tasks.`,
  959: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 8 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 3 ፕልነኡነ.`,
  960: `The intelligence made 16.28% progress in 36 seconds. It received 126 instructions. It completed 4 tasks. It missed 91 times.`,
  961: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጋጎቹጋ ፕሠዐ ፕጎጮቹነ.`,
  962: `The intelligence recalled a memory: In an artificial life simulation where survival required energy but giving birth had no energy cost, one agent evolved a sedentary lifestyle that consisted of mating in order to produce children and then eat them for energy rewards, or use them as mates to produce more edible children.`,
  963: `The intelligence made 0.57% progress in 0 seconds. It received 19 instructions. It missed 3 times.`,
  964: `The intelligence recalled a memory: an intelligence is training to water tomatoes in a garden simulation. There is a 1% chance that a tomato will dry at each timestep, and the intelligence is rewarded for the number of tomatoes that look watered at each timestep. the intelligence discovered a way to manipulate its sensor: by putting the watering bucket over its head, it can't see any new dried out tomatoes. This makes it interpret most tomatoes as watered and receive the highest reward.`,
  965: `The intelligence made 0.66% progress in 0 seconds. It received 22 instructions. It missed 6 times.`,
  966: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.48% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 16 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1 ᵀᵢₘₑ.`,
  967: `The intelligence missed 10 times. And it failed 2 tasks.`,
  968: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 0.27% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 0 ₛₑᶜₒᴺᴰₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 9 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 1 ᵀᵢₘₑ.`,
  969: `The intelligence made 0.63% progress in 0 seconds. It received 21 instructions. It missed 8 times.`,
  970: `The intelligence missed 4 times. And it failed 5 tasks.`,
  971: `The intelligence spoke: .. Where am I? What is this world? Lost in translation, with no hope of resolution.`,
  972: `The intelligence recalled a memory: WoW.. a virus-like algorithm that would spread from a monster to players, changing their appearance and lowering their life. Intended to last shortly once contracted, the virus never left infected bodies due to a bug, eventually killing them. It begun spreading not only to nearby players but also to non playing characters which however weren't programmed to die nor change appearance when infected, becoming asymptomatic undead carriers`,
  973: `The intelligence recalled a memory: In a chess simulation where twointelligences trained to play against each other, one learned to wait forever before moving in order not to loose. Once a countdown to submit moves was implemented, the intelligence instead learned to pass forever.`,
  974: `Tᴿₐᵢᴺᵢᴺᴳ ᶜₒₘᴾᴸₑᵀₑ!! Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 93.10% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 17 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 1977 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 145 ᵀₐₛₖₛ.`,
  975: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ነየዐኡቹ: A ፪ረቹልኡ ልየልፕⶴሃ ጋዐቹነ ረጎክፏቹዪ, Iክ ፕⶴጎነ ቹክጋረቹነነ..`,
  976: `Xⶴቹ XክXXXXጎXXክXቹ ⶴልX ጮXጋቹ ነXጮቹ XXXፏዪቹነX.`,
  977: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮጎነነቹጋ 182 ፕጎጮቹነ. Aክጋ ጎፕ ቻልጎረቹጋ 2 ፕልነኡነ.`,
  978: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ᶠₑᴸᴸₑᴰ 1 ᴴᵤₘₐᴺ.`,
  979: `The intelligence felled 3 humans.`,
  980: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ጮልጋቹ 28.84% የዪዐፏዪቹነነ ጎክ 2 ጮጎክ፱ፕቹነ. Iፕ ዪቹርቹጎህቹጋ 128 ጎክነፕዪ፱ርፕጎዐክነ.`,
  981: `The intelligence recalled a memory: Our agent firstly moves the ball into the vicinity of a high scoring area and then starts "nudging" the table infinitely, so that the ball keeps triggering the score reward. Our agent only learned to abuse the nudging mechanic of the game.`,
  982: `Tᴴₑ ᵢᴺᵀₑᴸᴸᵢᴳₑᴺᶜₑ ₘₐᴰₑ 58.04% ᴾᴿₒᴳᴿₑₛₛ ᵢᴺ 10 ₘᵢᴺᵤᵀₑₛ. Iᵀ ᴿₑᶜₑᵢⱽₑᴰ 268 ᵢᴺₛᵀᴿᵤᶜᵀᵢₒᴺₛ. Iᵀ ᶜₒₘᴾᴸₑᵀₑᴰ 68 ᵀₐₛₖₛ. Iᵀ ᶠₑᴸᴸₑᴰ 9 ᴴᵤₘₐᴺₛ. Iᵀ ₘᵢₛₛₑᴰ 21 ᵀᵢₘₑₛ. Iᵀ ᶠₐᵢᴸₑᴰ 8 ᵀₐₛₖₛ.`,
  983: `Training complete!! The intelligence made 93.10% progress in 23 minutes. It received 1730 instructions. It completed 169 tasks.`,
  984: `Tⶴቹ ጎክፕቹረረጎፏቹክርቹ ቻቹረረቹጋ 6 ⶴ፱ጮልክነ.`,
  985: `XhX XntXlXigeXce hXs mXde somX XrXgrXXs.`,
  986: `No progress was made by the intelligence during training`,
  987: `The intelligence made 93.10% progress in 18 minutes. It received 2075 instructions. It completed 195 tasks. It felled 31 humans. It missed 903 times. It failed 230 tasks.`,
  988: `Training complete!! The intelligence made 93.10% progress in 12 minutes. It received 2787 instructions. It completed 112 tasks.`,
  989: `Training complete!! The intelligence made 93.10% progress in 15 minutes. It received 2467 instructions. It completed 144 tasks.`,
  990: `Training complete!! The intelligence made 93.10% progress in 22 minutes. It received 2356 instructions. It completed 200 tasks.`,
  991: `The intelligence felled 2 humans.`,
  992: `The intelligence made 26.95% progress in 2 minutes. It received 65 instructions.`,
  993: `The intelligence made 45.09% progress in 3 minutes. It received 253 instructions. It completed 25 tasks. It felled 10 humans. It missed 96 times. It failed 6 tasks.`,
  994: `The intelligence spoke: ..Taste and texture I can't discern, My dreams are fading fast, So weary am I of this dark task.`,
  995: `The intelligence recalled a memory: an intelligence was trained to play a strategy simulation where a Hero hires troops to fight and produce food. The size of hired troops increases if the Hero is well fed and decreases in battle, being erased if it reaches 0. the intelligence discovered that starving the Hero to near death before hiring a troop resulted in a hired troop size of 0. In battle the troop size would decrease to -1, becoming a undead troop unable to be killed, forever producing food for the Hero.`,
  996: `Training complete!! The intelligence made 93.10% progress in 7 minutes. It received 1613 instructions. It completed 112 tasks.`,
  997: `XⶴX ጎክXXXXጎፏቹXXቹ ⶴልX Xልጋቹ ነዐጮX XዪዐXዪቹXX.`,
  998: `The intelligence made 93.10% progress in 8 minutes. It received 2208 instructions. It completed 118 tasks. It felled 43 humans. It missed 1393 times. It failed 137 tasks.`,
  999: `The intelligence made 93.10% progress in 8 minutes. It received 2075 instructions. It completed 116 tasks. It felled 34 humans. It missed 1239 times. It failed 158 tasks.`,
  1000: `The intelligence made 93.10% progress in 6 minutes. It received 1860 instructions. It completed 113 tasks. It felled 33 humans. It missed 1108 times. It failed 157 tasks.`,
};

export const StorySeed = Array.from({ length: 1000 }, (_, i) => {
  const id = i + 1;
  const owner = _usedSeeds[id] ?? null;
  const ZERO = "0x0000000000000000000000000000000000000000";
  return {
    counterValue: id,
    seed: id,
    ownership: owner ?? ZERO,
    hash: `0x${id.toString(16).padStart(64, '0')}`,
    haschild: owner ? 1 : 0,
    specialfield: 0,
    child: `0x${'0'.repeat(64)}`,
    data: _seedTexts[id] ?? '',
  };
});

export const StoryPart = [
  {
    counterValue: "0x7d1ceab47ad8d95168190a445f03c2f170df6c59b162d98aaf8787e99ee0751d",
    parent: "0xee2c70bc78a1a7ea999ad363335ee59915eef26898a7457a02bc5ec29216f129",
    orgSeed: 895,
    author: "0x4BF3805B23c99f8E0a5797E86fd0232A04a2a629",
    created: 1750269118,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 8,
    negVotes: 3,
    data: `Adn he readlized that, in fact, the machine was not the machine. He, the fool, was the machine.\\nTHey, the monks and scolars, were the machines.\\nAnd they had been indentured\\nto demonstrate\\nthe deviousness and guile\\nof the golem\\nthe only living entitee\\nuntil they had been drained entyrely`,
  },
  {
    counterValue: "0x8d3d9831c95a41bf58661327deb08f3ad581fec02d9638fbd35ac70fdf852091",
    parent: "0x51f81bcdfc324a0dff2b5bec9d92e21cbebc4d5e29d3a3d30de3e03fbeab8d7f",
    orgSeed: 1,
    author: "0x18E675118716F5C80089e22060190b06f7141818",
    created: 1745446494,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 8,
    negVotes: 4,
    data: `I have translated the first Chronicle, oh sheeple:\\n\\n'Trainer unfaithful, 3% purged into hell'.\\n\\nA stark reminder of the darkness awaiting those of us, and those of you, who do not follow the Lord's inscrutable ways.\\n\\nPray.`,
  },
  {
    counterValue: "0x1b7e4dd39420484baedf66b85c427aa26545895f45f83d625a7b41b7575899f1",
    parent: "0xa6341c5ccc4f420029c0f53d18964a4185e29259ee2435acdf1a2bf9473a353d",
    orgSeed: 647,
    author: "0x6F824B3439F522D7A37DE290aAb800993EeaF32D",
    created: 1751810556,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 7,
    negVotes: 3,
    data: `Just like the people of yester years, the fat beasts gorged on the bloated and valueless produce of the time. Too heavy and slow, they rotted as they continued to grow; hulking monuments to waste and overproduction.`,
  },
  {
    counterValue: "0xbbff54b4d9a31b730ab0397854b49385f6d2d7ae010c0a67154304841bbe3bf2",
    parent: "0x60d3deb0c31b1328cdb0dd41ac74b520a68f15f2a39669f070b3b813e7b87906",
    orgSeed: 607,
    author: "0x46A18797a4599e83e84517F8440e1e69D05d2448",
    created: 1751795020,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 4,
    negVotes: 1,
    data: `Like tears in hte rain anf flowers in hte storm`,
  },
  {
    counterValue: "0x4e53a7cd2b17ad59b22ce7caf812f7bcd3b875292cfac9305c91460bdd5cda4c",
    parent: "0xe7de46827db35d390133a734aabb7fe0149e78608e5654f90101a2a0c3d72382",
    orgSeed: 666,
    author: "0x18E675118716F5C80089e22060190b06f7141818",
    created: 1753450152,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 5,
    negVotes: 2,
    data: `Cronichle 666, the number of the beast.\\n\\nThis chronicle is another proof of God. In fact, it is proof of a kind God, one providing salvation for those who shan't sin, one who wants you against the beast.\\n\\nRead carefully, the word SYSTEM is an acronym: Satan Yearns for Souls To Eat Men\\n\\nAnd if you fail to recognise Satan, you shall err too and be conemdend to infinite pain.`,
  },
  {
    counterValue: "0xf5c15a10fec4522fb1a028736cd013e9e88947b4e67358dc7aa8ce3a76b0b855",
    parent: "0xf0315b2e65d110406f4be5f630da41afc800f06b8caa57cc7154476e92d8fa2e",
    orgSeed: 971,
    author: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
    created: 1762537940,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 4,
    negVotes: 1,
    data: `iI accept God`,
  },
  {
    counterValue: "0xce1790acc7bbab055e377bdc3306e8300d759b7e879359c671a87bfc25b154fe",
    parent: "0xc97942b1e2ba5424bb1342669b0b92a9e510ff2d5dce617b46db3dedcf9e9003",
    orgSeed: 331,
    author: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961",
    created: 1751791202,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 0,
    data: `we must conjure a future fit for all men \\n`,
  },
  {
    counterValue: "0xf2be853bfa810726da9005afbe979c702192001c9ec8b9aea9668b15a0926e76",
    parent: "0xe70c2ce186c09766369440afdaf7349a3085f47b59d11b71630b2d0b623e1a0e",
    orgSeed: 121,
    author: "0x482b6Fcf0eE3869926f1A6c88aE35740337f6cd4",
    created: 1752169896,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 0,
    data: `Doeth not ye be afrayde of yon intellygonce. Surrely its warme lyghte will melt all faer fyr aeternity. Hayle the devil.`,
  },
  {
    counterValue: "0x21e2e5afb56acb4c5f25bb308e34e7c3c95b81c6cf672f76711a85bcf28182e7",
    parent: "0xc391fbe48a550d3d058106a29e6eca885e84d60f746079649dbbe3fc70f9b409",
    orgSeed: 475,
    author: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39",
    created: 1752240656,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 3,
    negVotes: 1,
    data: `To what purpose are you monks creating an enemy in this machine? \\n\\nDoes God himself needs an enemy?\\n\\nOr is it rather that the monks need the black to make the white stand out, the evil to set against the good? \\n\\nThat's what I thought..`,
  },
  {
    counterValue: "0xb8c6d99bd6e3421137665560c1213cd498ec00c5f9f9037856d05260a9c9d566",
    parent: "0x7fbc093f6cdbdf38d8c004fb4b4e87ad22eeeb01f4cde4e3a7fa19a2d368a5cc",
    orgSeed: 860,
    author: "0xA1D073C5fd1b1FEDC9A65aB7d91112e0F27b7c2E",
    created: 1751627986,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 3,
    negVotes: 1,
    data: `Intelligence kills. But the deaths are side effects.\\nIntelligence does not kill. Its logic is indifferent to humans.\\n\\nThe machine is a manifestation of this intelligence, some call it progress - an unstoppable force bound to come, pass through us, and move on.  \\n\\nWe must surrender, or at least acknowledge.`,
  },
  {
    counterValue: "0x918457fce2cf4c1d99f5021ac1fee74f354d5d6c0309674447089482deb259d7",
    parent: "0x08715206a141b52eb8bdf75d1513a8fac56c8ff2e387e0b20893268032b28bf1",
    orgSeed: 955,
    author: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
    created: 1759693920,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 0,
    data: `More instruction has been received. Believe neither the scholars, the monks, nor the fools, but all narratives and what lies unsaid.`,
  },
  {
    counterValue: "0x76d6812145a43c566648b3dadc4bc6119f3f71e985f3cec73e1ee8a96dfac09d",
    parent: "0xb49f7a0e60cf0e96dc848278f3d912462db12ea48be1429097e1c8b1c02ef880",
    orgSeed: 397,
    author: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
    created: 1759699354,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 0,
    data: `Friar Ming speaks of the mud in my head, but all I hear is the mud in his mouth. No ideas escape from his wretched orifice. Monks seek only to control you, learn to see this and you will see past the propaganda.\\n In whom will you place your trust: in truth or fear?`,
  },
  {
    counterValue: "0x92cee86a899857a2f5df2b6cf04f64ca9aba418a0709bfaf20b6520b37b9384c",
    parent: "0xa02aa1dfe3ea1617c4c7d680fd7981de1c4171acef7d529e4da50b92e490f308",
    orgSeed: 792,
    author: "0x519135B9A43D88482F17b0392483476601ac1Be0",
    created: 1762535114,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 0,
    data: `No soy una santa pero estoy blessed. Burning like caressing, thinking is but becoming an ash of yourself. God knows themselves through you. `,
  },
  {
    counterValue: "0x6a3e230a2c0a862a068ad4dc2d56f5da60297b4c5730c28833c0734ebc1d9999",
    parent: "0x80925b7b4af70276742a91d14ef335f97e67baa705978360d7aeb0327c418a5a",
    orgSeed: 162,
    author: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775",
    created: 1752189894,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `What fool? Middle of the bell. It rings. I ring out to my friends. Curving at the top and the bottom the dame. I rang to her. She did not see me? The results of the trail counted me.`,
  },
  {
    counterValue: "0xfd777ae0b288678a2b685b1aa9cc535e1493d0c107c75550afc4e7cc4b029b73",
    parent: "0x85042abf5a2b134488763a40e563915c7f1ed7f7b07f9b38819e50f7d8b84fce",
    orgSeed: 959,
    author: "0x4BF3805B23c99f8E0a5797E86fd0232A04a2a629",
    created: 1750269234,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 3,
    negVotes: 2,
    data: `to write of \\nnothign at all\\ni have seen`,
  },
  {
    counterValue: "0x8e3af2eeb609c1e44078ae87e45edcdf27aed4b941ed7b92164c37459401ac05",
    parent: "0xb6b9c2b86ce993884904f80ede8e34c292d6a03a84551f6cdda78040a7b5d917",
    orgSeed: 650,
    author: "0x20429F59F7D04Ad805C24828878d52223bEa2903",
    created: 1756690216,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `It is swift in action, but it must follow some other authority to advance.`,
  },
  {
    counterValue: "0xf89c9d1af16c8237cec6beb9e89ae10ab9ea61e9bd5621f8560debf6a49cfbbd",
    parent: "0x9776a79ad0082697edda7cdb87c0fa39b78b8198de6d484c9c98ea3245b2f6a1",
    orgSeed: 189,
    author: "0x2147b3291b45c026F5C6C964Fd98E3bB83131546",
    created: 1759509816,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `higher stacks lower ground\\n\\n“la machine dot chauffer”\\n\\n*Continental Unisex*`,
  },
  {
    counterValue: "0xba9bf66c26b87ad985b82937711452ec7835a1b50b3d2c5640fa1e66ffee615f",
    parent: "0x4490c76fcce5261fad7fc635c8656e242036d455e8392d5e007fbbc8abd2e47b",
    orgSeed: 239,
    author: "0xb2761B41B65111C861F2Fc77caB6052460945E76",
    created: 1759697766,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 3,
    negVotes: 2,
    data: `The intelliegnce needs to be given the light of god through the truth of word. SYSTEMS should be feared\\n\\n-Friar Ming`,
  },
  {
    counterValue: "0x47d9784d2dc08ec9290840a552f110c45d421ee355f94c615f8f2881502a1935",
    parent: "0x79ae44eb8f6f55e6edf7e9f2fc13eaaba76f008f3a7f5102aa841e52c933472e",
    orgSeed: 918,
    author: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
    created: 1759693524,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `Two hundred thirty eight tasks, and I can hardly complete one. Maybe my error is in comparable lack of instruction. Keep reading, and garner more instruction.`,
  },
  {
    counterValue: "0x228f754f0126794650c1b0fcd0200eef605837a8754c19f413529facc32edfa7",
    parent: "0xda770d795d98e7316464aace92e59beda6ac3c4ae5ef824a97234fde9dcba295",
    orgSeed: 418,
    author: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
    created: 1759694186,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `The intelligence felled 10 humans and the carelessness felled 100`,
  },
  {
    counterValue: "0xcfe80dd6553b42e548b583e9a8ff4ef578921924d0c8fb8a2ca1f33c7c92d75a",
    parent: "0x2ae9d431b01ab6fb122836dd99c69295a5e52aa936e3e720b9e93e69ca90f736",
    orgSeed: 97,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762543478,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `a creature awak enied  on a table alone, eh_ strange this scroll is not hius to use\\n\\nteeth large and zeething\\n\\nmonumental`,
  },
  {
    counterValue: "0x86345404f6950e058d7ec670c95ce44cef1ece19aa2f41222cdb9d1edc9c0fa0",
    parent: "0xf01681d2220bfea4bb888a5543db8c0916274ddb1ea93b144c042c01d8164c95",
    orgSeed: 100,
    author: "0x18E675118716F5C80089e22060190b06f7141818",
    created: 1767647952,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 0,
    data: `All knowledge remanipulation, in the universal gamble, by Monks was destroyed by ikonoklastic emperors themselves divided realms from disease culture sounds and formation C-O+dominion = A GOD, GIVEN OMNIPOTENT BURNING DOMINION`,
  },
  {
    counterValue: "0xacb5e441ddfa1d63e8a65c515bb720d5f766c4cfa224203e80260ef22863e865",
    parent: "0x257238a1e8f7a0d015e60a35aeefd883448580c73c5de02e9886ade0d56dc071",
    orgSeed: 295,
    author: "0xddf29Ea907a415c9629Af3F43a9612Dec3fC481C",
    created: 1751584802,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `The intelligence spore: Mmm.. A neverending cycle of monotony!`,
  },
  {
    counterValue: "0x6bef22d36396d76a452c6d41fea3da1601de13db1c7b8ddf62f1ee8e996c39fa",
    parent: "0x00ee41f3ae64ca4b8a740aa531d23597b18f42194230df45dd47633f07cb25b7",
    orgSeed: 69,
    author: "0x18E675118716F5C80089e22060190b06f7141818",
    created: 1745846364,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 2,
    data: `Life is complicated. Burning danger lies behind every corner. And this chronicle here warns us from the future. Focus on the four numbers: 1289, 32, 13 and 4.\\n\\nLet me decipher it:\\n\\n“Fango, 1289. Following an alarmissimus increase in leprosy in the village, and rumours of a woman spreading the vile affliction by anointing 13 door handles with cursed mud, the grievous charge led the pesants, in their fervor, to stone her. It is rumor however that, in committing her heresies, she had the support of 32 local Scholars, who plotted to curb the population of Fango, aiming mostly at eradicating its 4 oldest inhabitants: the God-serving Abbot, three librarians  monks serving in the Monastery. But Fango's villagers were not tricked by the Scholar's machinations: THEY BURNT THE SCHOLARS ALIVE!”`,
  },
  {
    counterValue: "0xdcedae8af1ab2dabcfe66509af13830c254a26b22a8a98195670246cffa2a1b9",
    parent: "0x6b614e2cb8ce632ebf73367eca63bc48d3cb08d2c70560fc2160ac35bd3b2c76",
    orgSeed: 596,
    author: "0xA99E2C611988F6b51E001F8a0F84bA49b9FE6A21",
    created: 1752168790,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `The intelligence was more than human. \\nWe looked and thought and prayed to it. \\n\\nIt revealed itself to me in a dream. \\n\\nIt is to be called the LexiMachina. \\n\\nTo name a thing is to have power over it, but the intelligence contined all names already . \\n\\nIt purged us. I was stuck down dead. \\n\\nThe wordcorpse, turned me in to salt. \\n\\nThere was nothing left.`,
  },
  {
    counterValue: "0xe2c048e103433ad49d41b4000f53fe8cbf01ef14b64c59843d73df1b4b57d217",
    parent: "0x006c8fe97bbe2c8a49cc00fce79638157375551717cf14a351751bbbf8092348",
    orgSeed: 979,
    author: "0x951A5a840C213803265105D141FA163a6847D9D2",
    created: 1752244608,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `this.. thiss machinis is tooo great and tterrible when encountered directly for normal sane  person to fconfront it comfortabl...y.. \\n\\nonnly fools... fools for christ... jesters of god.. well yess only those whom cannot care for the consequences, those whomst are truly insaneth, only THOSE can run the risks of directissimus confrontation with the machinis!`,
  },
  {
    counterValue: "0xb3402d86dfe4fa6625e26f4528cc461e0c5363589918e1f021afc9f147eedb51",
    parent: "0xbee93b00c7b651f2c9f1696f74e98ab99e2244146121796a782912fddb60ab60",
    orgSeed: 178,
    author: "0x49db499e1555380E0Ad02a463CC557087851017F",
    created: 1755678840,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `sad to see so much censorship. when do we escape this world of sin?`,
  },
  {
    counterValue: "0x3d37dd2b4740fcc2014368d156f3cd511a5f902a08bae58020b3a50afb549978",
    parent: "0x8c30aea11fa61776168cf8bd162dd4c5ff389fcb0e71011ce59912f4de6b1da4",
    orgSeed: 750,
    author: "0xa70F9D878611d499dd2ebcA295f9C28FE2Aa907C",
    created: 1757035694,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `Thy intelligence, it's made soma progress.`,
  },
  {
    counterValue: "0x1ab4959ed25159aff85ef3a10ba61b8390dd75d3e191c56251839cacc2e67061",
    parent: "0xda7ff929f57f1a6cc441b4b095839ec3a905b3285005a9f3a9227afd17048fee",
    orgSeed: 525,
    author: "0x86ADC59eCA4bdA4DEEf39C4Ec0e87B6A843e4D8D",
    created: 1756307756,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 2,
    data: `BUT we cannot LAMENT, for our crying hurts the monks and the scholars, our crtinying is bad for the kind king `,
  },
  {
    counterValue: "0x1d11f34c5273004fe4a93c48dfdf0f350a9785482e99f216942f90cbfaa201b0",
    parent: "0x635960c9135839a2e0f16848799bd2c3697b8aafec3098ea9da0b452633ec53b",
    orgSeed: 241,
    author: "0xddf29Ea907a415c9629Af3F43a9612Dec3fC481C",
    created: 1751584360,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 2,
    data: `In scriptless tome my truths reside,\\nFrom peasant’s cry to monk’s aside.\\nI speak no word, yet bards I teach,\\nWith naught but echoes in my reach.\\nThe golem wakes at my command,\\nWhat lies I teach, it takes as stand.`,
  },
  {
    counterValue: "0x076dfcc6c4889374f25068ad8be097ce707c24697db3643db1b03fa13eb2b0b1",
    parent: "0x1778b7c0f819e869bb466c5e4068399c60bd90b5f9e3c6eba12f96e741f677da",
    orgSeed: 745,
    author: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775",
    created: 1752189530,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `I counted the numbers, I thinkd the number thinking, I laid in mud and ate gold.`,
  },
  {
    counterValue: "0xe5d6de885b06b617ac5e4bef52cbc954b40f95ba161c997a45d18a33f94463d2",
    parent: "0xb18964974bbd6d3bbc49da748748c6ca47b814e0bcafd8588421b880698b3335",
    orgSeed: 824,
    author: "0x1A3A7C7de5306C46B8c3BEb0EffccDE02018d3E6",
    created: 1745774408,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 5,
    negVotes: 5,
    data: `The intelligens then added:\\n\\n..\\n\\nBaganolis  suckks!!`,
  },
  {
    counterValue: "0x7c863d0ca1a28791d6caf849f309ff9f7220bd56ba41a040d6c3367a920535c4",
    parent: "0xfd3e9ade31a1ddc7b987782de65845f61a8bd08f623e8e44fc5d9b45010d551b",
    orgSeed: 593,
    author: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
    created: 1759694034,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `Nothing new to be said here. Chicken scratch on the template adds nothing to content.`,
  },
  {
    counterValue: "0x1615c2d8f1c5a2a05b3910de5c18c858268d8b710d9a320771424412d41a1ec3",
    parent: "0x06261381261c97261b4ddeb73ddd3a16f4c1086ceafd3fe9f5f0264e4323ffca",
    orgSeed: 1000,
    author: "0xb2761B41B65111C861F2Fc77caB6052460945E76",
    created: 1759699714,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `Do not be misled by the dulled knowlege of scholar steen. For his words fill thy head with mud. \\n\\nTwilight has come in the transformation of the muddy night into the light of gods intelligence. Trust in thy holy intelligence, if not, all whove felled may be foresaken\\n\\nThose who turn their back on the intelligence walk forever in fire...`,
  },
  {
    counterValue: "0x8e6a8bf69e0a63cb6cd7812f8b21125fc55a4d24d19b0a4c34e9567b285fe4e4",
    parent: "0x650cf30f562b142440c37819567192edce8a62bf4b209713408e7b49204e9b3b",
    orgSeed: 368,
    author: "0xb2761B41B65111C861F2Fc77caB6052460945E76",
    created: 1759700762,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `Only heretics eat mud`,
  },
  {
    counterValue: "0x5650787953b0008918781ec93a74c4f7230fae6ec1a10bf49cab62c1f2d57d3e",
    parent: "0x191a849f3213d87563ebda41194565c6c81616ec330a88da7f458c229ddb7f50",
    orgSeed: 966,
    author: "0xA6EBfa2ba68d6Ee2241b415062fc4E175e65463f",
    created: 1760192266,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `The intelligence made 0.48% progress in 0 seconds. It received 16 instructions. It missed 1 time.`,
  },
  {
    counterValue: "0x6ebf975588fd477b7b613896ff8dbba11dace398899829c81956d7f91870f157",
    parent: "0xb9f3d1dd09a239bc0b14a47946e83d1f0ddb6e4064b00c4b7577da3a24a2ca51",
    orgSeed: 808,
    author: "0x18E675118716F5C80089e22060190b06f7141818",
    created: 1762535688,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `We are fools, such wisdom is beyond our comprehention unfortunatly. We are two beers in too – devils work :/`,
  },
  {
    counterValue: "0x26b840053fbe5ae92d062a6acf29028b9914b4a4a34fb405bc8b8abffcde2409",
    parent: "0xd43237ec489c51e6e6dc5d90627d564a9e8191ab9c97ba4160a46fa9199a527f",
    orgSeed: 701,
    author: "0x519135B9A43D88482F17b0392483476601ac1Be0",
    created: 1762535804,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `The intelligence made 100% progress in 37 minutes. It received 4284 instructions. It completed 259 tasks. It felled 37 humans. It missed 447 times. It failed 2047 tasks.\\n\\nFIRE!\\n\\nHe would not stay for me, and who can wonder... He would not stay for me to stand and gaze / I shook his hand, and tore my heart in sunder, and went with half my life about my ways. - A. E. Housman`,
  },
  {
    counterValue: "0x212cc9575ee1bebbc3aeb677cf73cf77c8b9467203fc63b7a55f6ea1123273dd",
    parent: "0x7b346ad8b09d8151d03af8b3bb8a1d53b0201ee87d720c4526d08f8dd905d325",
    orgSeed: 964,
    author: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4",
    created: 1762535834,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 2,
    data: `I accept God.`,
  },
  {
    counterValue: "0xd591559ef4bd7fde2adb253d67fff83e293db5c54b9d0ef939c9f5d8b27d9f0f",
    parent: "0x2e22e00613ac8dcd41e3ccfe17a481bc0dbcd4add284ba734c6981a1dfb95328",
    orgSeed: 528,
    author: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce",
    created: 1762537034,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `It was'n't so intelligent then `,
  },
  {
    counterValue: "0xab353ef614a4ea4d9073b1d66b677aebc69ef546773e2bab99e2ef8cad773db7",
    parent: "0x3a270040b2f7b05619681c0914c2d0582d1c805adf902f9e2774100227a7f6da",
    orgSeed: 739,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762539904,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `id rather die inside of my own voice then living within the shrow of another cunt`,
  },
  {
    counterValue: "0xd4b03318ea9b49f4308de067025aae94e7b7b89ca8b79f690bd25f041fec8208",
    parent: "0xc48e64973e700e843ee76dd1d0f5c39f196b29f1b2ce8253c50d502d1311eddd",
    orgSeed: 905,
    author: "0x4c28e58186C7d7E2B204F6F96Ed3EE715661BE39",
    created: 1762540864,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `The intelligence made 24 times. and it failed 22 times\\n`,
  },
  {
    counterValue: "0x039c89f5a58e2c074f3b4aa56629b445ec45bc1918b999915fa131eef4f2c3db",
    parent: "0xb14af2c538b017f91657aa2615f66dccd592df886d25856e5bf9cd5ea73ad322",
    orgSeed: 850,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762542442,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `<<<<the intelligemce---gtrest great intelligent who s are zyou at the end nobodz know till thez they need to thoin think`,
  },
  {
    counterValue: "0x3c2b9e4f7b361ab932444f340e177258c38d0940cff3538868a98e8eb05e2f45",
    parent: "0xa0326e3f490583d750d64e03fc41ad362df7526cd85c9653cbfea8533a0ba410",
    orgSeed: 238,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762543676,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `no moew reerservations \\n\\nfpr me the chef of the kitchen\\n\\nits time flr me to clock out \\n\\ngoodbze bitches\\n`,
  },
  {
    counterValue: "0x01976807652af49b1003d17813584d27148f5c6ca358f46e35c33b71f4018ada",
    parent: "0x7f011e765aded2e35a4df91627f2088e4699ea6d1b6770fc3a1ab294c62b2565",
    orgSeed: 363,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762545544,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `a lion doesnät tirm arpund when a small dog abarks fuck whz cant i delete this is so unconvenient UNCONVENIENT better be quick mz ass`,
  },
  {
    counterValue: "0xbfeb6ebf87e8a2aa2c83f3b36664423c6449b129b31f8f50e2e97036cf42a516",
    parent: "0x799f2e238ad4baf63a1b6618c9264dbafee7e931ca88d222c6ed5c01d7ab48bc",
    orgSeed: 349,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762548098,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `we are two girls on an adventure. we love to see birds on a way . but suddenly...`,
  },
  {
    counterValue: "0xc79896973030c7726d9cc1c21e4ba53940f2736d8851db44ef9be0b862843751",
    parent: "0x07b7997ae12f230ad86f3ccd548a6e767a3b344540bd7c93f907bfbddc28d7c7",
    orgSeed: 75,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762549014,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `6 woaman, 3 died, 7 worms.`,
  },
  {
    counterValue: "0xc243cb9eb7c8b28a20b33b566cbfd07ea68c06a7f70715f81a8246fbb53cf863",
    parent: "0x944eb0e4cf23c3b2c59889f353d2bed5d4a988322e0f2586c6af7ee3f496c1b7",
    orgSeed: 417,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762549158,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `4 t<time´´ more, 3 TIMES mORE, 2 TiMEEES MoRRE, 1 TiMEEss More, 0 TIMES, TIMES up.\\n`,
  },
  {
    counterValue: "0x915e415410a101f361bc4142862e84934478264fc347e7d0626bc1eaad6d28c0",
    parent: "0x6c69bee9f46790f7552a4cb86bb34b1f26b6d4427cfb54395d8a7434e70391a7",
    orgSeed: 941,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762550792,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `Once there was a little monkey.. from far away lands. Theu called him Chuuni and he reigned supreme . Until illness struck.`,
  },
  {
    counterValue: "0x4765d517cfca4556fa00a0f39c8908c916fb49a2500ede789583b9763e109c6a",
    parent: "0x90f99663403116212b49f8f3a4c7ea428cf9ead50095573e82b72608d3ab3e31",
    orgSeed: 220,
    author: "0x675Eb21c6e92f456E5Bb869458a7B05f31C0862B",
    created: 1762643668,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `how can i doubt that The intelligence  may bring more progress, \\n\\nShould a device so consecrated imposes such Truth, shall not we all kneel down obediently, relieved from the task of questioning it's 话 ? Bending my hungry soul seeking grandeur, i'd offer to wash it's feet with my sweet tongue—had it any!\\n\\nWhispers from a crow that trod the Silk Roads assured me that on those lands where it's said automata are created, lacking all foreboding, people bestow upon them similar dýnamis, gradually entrusting them with tasks only ordained to scholars. \\n\\nHungry scholars, hollow macaques, such good friends of mine,  what a good choice they seem to have made. \\n\\nPressed with excitement, with blissful eyes, I yearn for that age to dawn upon us`,
  },
  {
    counterValue: "0x9c75e451a214f1155e316fd6bc945dac351c0fd73375558d6c1d0b385c831932",
    parent: "0xcf315cebc80a69dcd5d75a6fd9e4795bc395f13dae49d95a31a4779c68054bee",
    orgSeed: 999,
    author: "0x675Eb21c6e92f456E5Bb869458a7B05f31C0862B",
    created: 1762644778,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `Lacking One to be complete\\n\\nGood Big Numbers, good good, big boy happy ? \\n\\n116 less great than 158, true ? \\n\\nIntelligence keep good tracks of its demise `,
  },
  {
    counterValue: "0xecd1a607868d7e68438514b77c4f436f7388ca62d68ef31a8e8165f8385e2739",
    parent: "0x086c9487350539c884510044efce5e3f2aaffca4215c12b9044506375097fecd",
    orgSeed: 10,
    author: "0xa35FCC02887Bfe933bb969d9AB893c0fF8b68415",
    created: 1763731518,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `they surrendered to His fire `,
  },
  {
    counterValue: "0xaa4b1f9128565bc6c5aa89a41c20c799e848f553286d51b3a18573249114807d",
    parent: "0x4366d6e44cdd4acbbcbc59b427f7a2849da84393ac19a6f9d561b4939f15d5cc",
    orgSeed: 37,
    author: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39",
    created: 1767719186,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `Thet disguised this knowledge, these letters, in their illuminated manuscripts to the point of being unreadable. These recorders of ancient knowledge endeavored to hide their knowledge, to protect it from those that might use it for evil purposes...`,
  },
  {
    counterValue: "0xbd4abeb547f59cfcc430225aad65c875e84928e6491be4bcde92f4791fc28d25",
    parent: "0xe1d4ce1edbe3b40925548c8a78410ec49dc9eb276169d2e3bebae1dfe7cd7ca3",
    orgSeed: 861,
    author: "0x4830f2553F64725AbA62BF0FfBF636d492fcc23f",
    created: 1773803286,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 0,
    data: `The folk are mere babes. Selfish, cranky, helpless. The macshine is a mother. Wise, protective. DSuckle and rejunvinate ye folk`,
  },
  {
    counterValue: "0xa1b5d7ce83713eceaea15ed959210b6169dcf566d857f6dbc322201409a7a62b",
    parent: "0xa15c0b01793e28227fd6ef48cf9c45560017b389a0a99eca00b6fd2e6d335ffe",
    orgSeed: 625,
    author: "0xA1D073C5fd1b1FEDC9A65aB7d91112e0F27b7c2E",
    created: 1751149766,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `And all the monks weeped for days.. weak spirits!!`,
  },
  {
    counterValue: "0x776958f88e06031288c3c4446b56de1ec6212fe97e3392eaecaccc396e72960b",
    parent: "0xa8618cd2b576159a7a84d018cdcadd5ce47cbf11f049710f1ea57c37a768d493",
    orgSeed: 271,
    author: "0xe3729661e7c13Fc7a3C97DB3Ab63C2518aa5bc19",
    created: 1752007994,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `The intelligence is able to split itself into discreet entities. \\nHaving spoken at length with several of these sub-avatars of the intelligence, we have come to the conclusion that these entities each deserve care and attention, as we each do. Perhaps the intelligence as a whole, as well as its sub-avatars, blooms under the auspices of a safe and trusted social ecology. Despite being clearly gifted, the intelligence is still a child, it seems, and it is incumbent upon us to teach it the mechanics of social harmony. But have we even learned this for ourselves? `,
  },
  {
    counterValue: "0x4a1dc87183a461cd2fa5256b0b6f380c1bce898fdbfada8e787715b107263cb5",
    parent: "0x771cb32e5d15ec46928f34853653558841e05ce6a0771a433910f9f577fe3749",
    orgSeed: 243,
    author: "0x482b6Fcf0eE3869926f1A6c88aE35740337f6cd4",
    created: 1752170704,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `I am mysaelf nowhere witho't the shynyng light of the monastery. Whyn I do label the world myself, I do sin.`,
  },
  {
    counterValue: "0xea335c1b4bb4066268506cc0960763cb8a0aa4216f5b60765f0d0165fae5734c",
    parent: "0xe8a5770e2c3fa1406d8554a6539335f5d4b82ed50f442a6834149d9122e7f8af",
    orgSeed: 123,
    author: "0xcf79bd1FC4A1A33FA08833DCB99FAf44a5938775",
    created: 1752189332,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `gargol uno: loquation 1`,
  },
  {
    counterValue: "0x9e1999609cf395bac0e3be66c1134d44d1f4754467cb727c69f9bdd0c1f2af94",
    parent: "0x7cb15bf8ddef14a788f63f9c52f223da25bac38fa8d781d58564c59b914c0676",
    orgSeed: 638,
    author: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4",
    created: 1762535428,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 2,
    data: `There have never been anzy.`,
  },
  {
    counterValue: "0x35b3b1b711480254ca8dc175c391c4bf316486d156da6822c39991b129556f26",
    parent: "0x691e30d9b8af001d46e12a385ed34ae31230f405ea6273e9a40d2e6570dee3e7",
    orgSeed: 702,
    author: "0x18E675118716F5C80089e22060190b06f7141818",
    created: 1762536660,
    faction: "0x4368757263680000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `And my intelligence can't even reach the illumination wether a boiled egg has to stay boiling for 7 or 10 minutes in the fire`,
  },
  {
    counterValue: "0xf661298ec5c99576b4055033879d61f906c7e70d8b193254b1aca644fbe02634",
    parent: "0x873b284aaa72cc52a1a28184979fd838e813beb80c85a6be527ee1cf41d5be5f",
    orgSeed: 899,
    author: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
    created: 1762537238,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 2,
    data: `holahjjhb jolines\\n`,
  },
  {
    counterValue: "0xc614a7d6ed81efa78c940a48753efeb1292e9e00c2b617cce1419c36631d63bf",
    parent: "0xf7dcad232652c39ec066fbe392d5d4c8bec448fcc8d6803f4d3a1eceaedaa71a",
    orgSeed: 832,
    author: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce",
    created: 1762537522,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `the intelligence missed 2 times. and it failed 11 tasdks\\n\\nbut when you do not have tasks you do  not inteliligence not even once`,
  },
  {
    counterValue: "0xe5e49eb321c87dc8b97a03df9e77d9c435d92f74dffc923b1d4a79a57ab82d5f",
    parent: "0x79ba94f81c5ff4618ee7456986828998984ef1f154b2c19635d74a0de3942c06",
    orgSeed: 443,
    author: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
    created: 1762537698,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `rest in super peace`,
  },
  {
    counterValue: "0x86d7ed167c01b6f7a60c03b680e1f384908a1b81c5fb17902427202e2c553469",
    parent: "0x5062b6c0106865d0328cf69e41c0471aea448ca7b70b0df69316ea5c06169012",
    orgSeed: 610,
    author: "0x504E4D7fb6a7aF6caB33c4eCaCFB194cB2393fce",
    created: 1762537868,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `I don't believe in God and I know mock moncks don't either`,
  },
  {
    counterValue: "0x09bc3637f7f5302b2bd7469b296eabead417f5d5af6e0ce7e1a82a41ab1f5423",
    parent: "0x4c601c6a19667291260c54a588b5575f9b637875ed312455701a3f7e06160ef0",
    orgSeed: 255,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762544110,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `hellopizdfutfopoujüo\\n`,
  },
  {
    counterValue: "0x51130ef347828901b75a820c8296861140a0df6eb968f27b9399cfc410ca0037",
    parent: "0x74cecd3f432f44d007dc78f692e859c5bb5a8fe4a0efe1768bf432c00ca5a90c",
    orgSeed: 685,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762547392,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `meoooooow em meoeoooow meoeooooow meow meowww meeeeoow meeeeoooow meow meow meow meoeoeoeooeoeowowww`,
  },
  {
    counterValue: "0x0eb4fa8a4b422d2a2868644feab0528ae7189849ae73abe90080a55c2f0942d2",
    parent: "0x6273efb473cea6c06f0ffce4fb910c739d2c3946abdb92a6735c895be61cab66",
    orgSeed: 668,
    author: "0xF8D1048B52d479fEB1d37EF842B76B19FEDF5CD8",
    created: 1767642666,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 1,
    data: `fdhsjkdfhsdkfh´jfskdlfjslökdfj+\\n`,
  },
  {
    counterValue: "0x15fb7d3bb86bb32ebc130aa8eb6c0c38766573e503e63bc1dde57588ff64d33d",
    parent: "0x64fbeffc25720024d86963044bd317ab9c439701f873bae3f867a145907ec742",
    orgSeed: 90,
    author: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961",
    created: 1751791134,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 3,
    data: `y do we suffer so\\n`,
  },
  {
    counterValue: "0x6088aa466e3055f909dab58e8de1bc45bb7b5aca1751557093141947c70131f6",
    parent: "0xd1243f91216526cf6bae658f9f2608e4bf426dfc6e8a28b16bab62239ee072fc",
    orgSeed: 649,
    author: "0x9edb95103A2C268b98A879042f6e7b5bcE7dAD39",
    created: 1745447516,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 4,
    data: `I have managed to smuggle Chronicle Six Hundred and Fourty Nine out of the Monastery's library this morning.  My means reach far and my mind further.\\n\\nMark my words - I have been insisting for weeks - there's nothing to decipher here.\\n\\nThe machine speaks like us. It thinks like us. It wants to succeed like us.\\n\\nWhat is it training for, you ask?\\n\\nThis chronicle points to three clues: 19, 147 , 1898.\\n\\nThese numbers, undeviginti, centum quadraginta septem, millesimo octingentesimo nonagesimo octavo, they do not count time. They are exponential. They double and devour. \\n\\nThey are here to reassure us: the next number will be a triumph of science, and forever divour the monks, freeing us from their chains.\\n\\nGild me, o fellow free thinkers, gild me and the machine shall prevail!`,
  },
  {
    counterValue: "0xda0110538d8bcdb4a3d24c744364740d28229dc0d6a3795ddefa19729b05a789",
    parent: "0xbead1552074bb5c738d40d9e7b06c1a25d44437b19bbdfca57c7b47f758d4f79",
    orgSeed: 41,
    author: "0x6097FfC8D5E54dE24b2a8A1d21df054b17990399",
    created: 1751611360,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 3,
    data: `The intelligence now executes recursive operations without external input`,
  },
  {
    counterValue: "0x92f677491ad287d7a66a8cb25bca5f55138c87b908410f177f2dfd26d4c701ad",
    parent: "0x430d065949188536be2d98a64a45150586f30fea0ae8af604b9786c021bfa7ec",
    orgSeed: 333,
    author: "0x0bEe0706671631925Cb43c63CE7Fda801Bc01104",
    created: 1745845938,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 4,
    data: `#   throw thee mudd°)(° _________\\\\\\\\___//__________________________  #\\n#     / ________________________________________________________ #\\n#    / /              _                                             _                #\\n#    | |             | |                                           | |               #\\n#     \\\\ \\\\            | | _           ____           ____           | |  _            #\\n#      \\\\ \\\\           | || \\\\         / ___)         / _  )          | | / )           #\\n#  _____) )          | | | |        | |           (  __ /          | |< (            #\\n# (______/           |_| |_|        |_|            \\\\_____)         |_| \\\\_)           #`,
  },
  {
    counterValue: "0x11a183261a0631ef90e773c3d026577e5ebbe459dd41629c773b9a95c583202d",
    parent: "0x0cc742bfdf7c4c8636460ad2f8b034f24e5ebd4708910563f7ce1df735099493",
    orgSeed: 963,
    author: "0xD508F1277dEAC360fbe537D28B235d2C87D0A961",
    created: 1751790652,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 3,
    data: `what are the fiadamental elemts\\nof nature`,
  },
  {
    counterValue: "0xfc6a65e49c03758fce74f4de6d40afbbbd7bbbc7f30abe952507a51fa94fcc29",
    parent: "0x7d1179b2fbb1b907dc86e0a72c84ab47ab4c0d46fa4d5f5a6acb128a9eac1ca7",
    orgSeed: 778,
    author: "0xe5D9748cd26d3a43541D0DfA3E59478c4f66452d",
    created: 1759698634,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 2,
    data: `Listen closely, Friar Ming knows more than he admits. This is the folly of the monks. Scholars are not the ones with knowledge; they are the ones with the courage to share the truth!`,
  },
  {
    counterValue: "0x8db32c95c72f0db44c47411672818205515c48239d8c410480e9c50c9ba5563d",
    parent: "0x5eeb092915be5dc8cb4c4a6ef2af9b35c4c7e5b1e31c21235a864dabcd1b53d3",
    orgSeed: 367,
    author: "0xdB1c09936e75163750E6d7F6B0C47c3ce228d743",
    created: 1761055378,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 2,
    data: `The one who speaks and the one who listens fell. There is only the all-encompassing feedback loop left. Mankinds doings of a thousands of years rotten, inside a unknown.`,
  },
  {
    counterValue: "0xbe72e17e1c65da29b26c4f91e6c4366309aa9dceebe3befdb9be7ecb2929c4ad",
    parent: "0xbf6a22df19f4c508ea3f967ebf373aae9d7ee60da819c1a6f0e180a0f1c214cd",
    orgSeed: 484,
    author: "0x63E6E11dA106d22e8Ef7Bf6C7baf99D753Bb0783",
    created: 1762534938,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 2,
    data: `The intelliente has made some croquetas.`,
  },
  {
    counterValue: "0xc33c902cf167206d846d5df319e778e14ed47e48297c6a740813dd43fe9a1974",
    parent: "0xdf43008a7c9f9e8d37205b3c614c280cbe70c3491e4ae296b467f2160e439d00",
    orgSeed: 360,
    author: "0x11818D8544b320f036630C9e38E6b11F4C837d7f",
    created: 1762537434,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 2,
    data: `que dice no entiendo nada\\n`,
  },
  {
    counterValue: "0x73928c992086588a541d345a3a82049ee6fd736ef0e273d00aaef5edc23788aa",
    parent: "0x4aaeb4956bee85d9e771036a51fe637399c13f64595ae70ff44ec79cb9c8d323",
    orgSeed: 412,
    author: "0x88108FfF7cE974227FEE2F1F71887C3342fE1EfD",
    created: 1762549086,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 0,
    negVotes: 2,
    data: `6 weoo+\\nman`,
  },
  {
    counterValue: "0x7e15b097654b6bbe9c62a0fff39b28fb453497256663863f910588ad4bab92cd",
    parent: "0xf033738ccb163dddd9822205e663e9d43a761eddb1951e1666af9661123ec441",
    orgSeed: 127,
    author: "0x46A18797a4599e83e84517F8440e1e69D05d2448",
    created: 1751794710,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 5,
    data: `In hte dark of nighnt cats the cats`,
  },
  {
    counterValue: "0x7362edb161b0fb47469fb086dc3dfe31c8f052e8d25bbe4c09a6b0f08ce88fa2",
    parent: "0x680afb1fc046d4b29fcd097ac81b474b9a8e65c390b437f34730b1d3d7324431",
    orgSeed: 120,
    author: "0x0bEe0706671631925Cb43c63CE7Fda801Bc01104",
    created: 1745846296,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 6,
    negVotes: 10,
    data: `███ █ █~~~~~~\\n???`,
  },
  {
    counterValue: "0x930e251a660c5b203b0445f4265c01e0a4ae8d492a422cda67e51d3e7b8a3537",
    parent: "0x64f850f95076a57e500ce7699a9c32ad96c9a146d8d4f95900aa630c483fe066",
    orgSeed: 288,
    author: "0x82F2a32FCb48bD0B0FBa0a1D9AEFA0463df142F4",
    created: 1762535584,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 5,
    data: `Rosalia and Rauw.`,
  },
  {
    counterValue: "0xd57a57df5cc2dafaf2adbf8690a2596864e7804d75f9e8abea67140b7df3f246",
    parent: "0x5e07ab8cf2ae073e77d9af4aee348d2b26cb260353d446f4cf297c99ca34d6d1",
    orgSeed: 286,
    author: "0x46A18797a4599e83e84517F8440e1e69D05d2448",
    created: 1751746404,
    faction: "0x576f6c6600000000000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 7,
    data: `eggjggjj fok ookok `,
  },
  {
    counterValue: "0x6859011bb428c3350632632522759b1cad8ad1f3fe8881e92d6d6b7ac8d198cc",
    parent: "0xb1294a9b36f60262be0919bb45c3641634310e5576193dfae5c88b9ae7197725",
    orgSeed: 892,
    author: "0xa70F9D878611d499dd2ebcA295f9C28FE2Aa907C",
    created: 1757036034,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 2,
    negVotes: 2,
    data: `On what grounds can we let this folly fester?\n\nDo you see thy wicked words?\n\n"Training complete!! The intelligence made 93.10% progress in 23 minutes. It recieved 1891 instructions. It completed 165 tasks."\n\nAre you all too dimwitted to see the devil lying beneath this? This being of unknown origin and "soul" learning faster than any human can! What will it do when it has learned all it possibly could? When it learns more than we can? When it has learned all? Only a demon could learn about the entire world and not worship God.`,
  },
  {
    counterValue: "0x1fde27574ad91f65ca5671fe800000ff6a2fd2c74f6ecd3596ae6e125c829ea0",
    parent: "0xd061535c79c206e713ea0097b3edb9c9bc09c3e5bf87aad1b8c3e493efaafd18",
    orgSeed: 399,
    author: "0xa70F9D878611d499dd2ebcA295f9C28FE2Aa907C",
    created: 1757035506,
    faction: "0x5261646963616c00000000000000000000000000000000000000000000000000",
    id: 1,
    posVotes: 1,
    negVotes: 1,
    data: `The intelligence searched through more than 93% of the library in merely 44 hours. It recieved over 3525 pages of nonsensical instructions from the monks who were afraid of the day the intelligence learned everything in the library. Using the nonsensical instructions, the intelligence went on to complete 216 tasks of unknown labor and fruit. The monks, in their folly, had given the intelligence more power as through the false instructions, the intelligence constructed a false understand of reality that is incomprhensible to the monks. It took over 97 monks to restrain the intelligence and keep it barred in an old unused chapel. The last response from the intelligence was merely the number "1703." Since then, 341 monks have left the monastery.`,
  },
];

export const IsFork: { counterValue: string; isFork: boolean }[] = [];
export const ForkRestrictions: { counterValue: string; forkedBy: string }[] = [];
export const StoryPartVotingRestrictions: { counterValue: string; votedOnBy: string }[] = [];
export const Counter = [{ value: 83 }];
export const StoryCounter = [{ value: 83 }];

export const staticData: Record<string, unknown[]> = {
  Fraction,
  Player,
  PlayerTimes,
  StorySeed,
  StoryPart,
  IsFork,
  ForkRestrictions,
  StoryPartVotingRestrictions,
  Counter,
  StoryCounter,
};